"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[637],{

/***/ 77307:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "gWQ": function() { return /* reexport */ fantasy_slice/* initialFantasyState */.gW; },
  "lF6": function() { return /* reexport */ fantasy_sync_api/* useConfirmFantasyLeagueSyncMutation */.lF; },
  "Idi": function() { return /* reexport */ fantasy_sync_api/* useCreateManualLeagueMutation */.Id; },
  "YyF": function() { return /* reexport */ fantasy_sync_api/* useCreateUserAccountMutation */.Yy; },
  "J29": function() { return /* reexport */ fantasy_sync_api/* useDeleteMyLeagueMutation */.J2; },
  "EUg": function() { return /* reexport */ fantasy_sync_api/* useGetMyLeaguesQuery */.EU; },
  "jKM": function() { return /* reexport */ fantasy_sync_api/* useSyncFantasyLeagueMutation */.jK; }
});

// UNUSED EXPORTS: ACCOUNT_KEY, APP_STATE_KEY, BETTING_CART_KEY, BETTING_KEY, BOTTOM_DRAWER_KEY, CONNECT_KEY, DataProvider, FANTASY_FILTER_KEY, FEED_KEY, LiveDraftSocket, MOCK_EMPTY_ID, MOCK_ERROR_ID, SUB_KEY, SimulatorDataProvider, SubscriptionsActions, SubscriptionsAdapter, SubscriptionsHooks, SubscriptionsReducer, SubscriptionsSelectors, SubscriptionsSlice, TestDataProvider, WEB_VIEW_KEY, accountActions, accountApi, accountHooks, accountReducer, accountSelectors, accountSlice, activateSubscription, addToBetsCart, appAdapter, appHooks, appReducer, appSelectors, appSlice, authStateAdapter, bettingHooks, bettingReducer, bettingSelectors, bettingSlice, bottomDrawerActions, bottomDrawerAdapter, bottomDrawerHooks, bottomDrawerReducer, bottomDrawerSelectors, bottomDrawerSlice, clearAllBets, clearBetsCartForSportsbook, closeBetLimitModal, closeBetsCartScreen, confirmFantasyLeagueSync, connectActions, connectHooks, connectReducer, connectSelectors, connectSlice, consumerApi, createAccount, createManualLeague, createUserAccount, defaultBetProductData, deleteMyLeague, fantasyActions, fantasyAdapter, fantasyHooks, fantasyLdaMdsApi, fantasyReducer, fantasySelectors, fantasySlice, fantasySyncApi, feedActions, feedAdapter, feedHooks, feedReducer, feedSelectors, feedSlice, fetchRankings, getAccountState, getAppState, getAppStatus, getArticleByIdOrSlug, getAvailableMarketsByEvent, getBettingCartState, getBookmarkedArticles, getCheatsheetPlayersFromRankings, getConnectState, getCurrentEventWeek, getCurrentEventWeekPlayerPropsAnalysis, getCurrentWeekAndEvents, getCurrentWeekEvents, getCurrentWeekEventsWithMarketData, getCurrentWeekPlayerPropBets, getDraftBigBoardData, getDraftBigBoardMetadata, getEventsWithInsights, getFantasyState, getFeedCategories, getFeedItems, getFeedState, getFunFacts, getGameTeamGrading, getLandingPageContent, getLatestArticles, getLeagueDraftPicks, getLeagueDrafters, getLeagueKeepers, getMatchups, getMdsResults, getMismatches, getMyLeagues, getMyLeaguesForMds, getNextPickInfo, getPaginatedPropBetsWithAnalysisByEvents, getPlayer, getPlayerGradesByIds, getPlayerMatchupsForEvent, getPlayersByIds, getPlayersFilteredByTags, getQuadforceData, getRankerInsights, getRankings, getRankingsForMds, getRunningOperationPromises, getSDKEvents, getSDKEventsById, getSDKEventsByWeek, getSDKEventsWithMarketById, getSDKHotPlayersByEvent, getSDKHotPlayersBySeasonWeek, getSDKMismatchesByEvent, getSDKMismatchesBySeasonWeek, getSDKRecentDefensesForEvent, getStartSitRankings, getSubscriptionsState, getTeamDepthChart, getTeams, getToken, getTopPlayersForEvent, getUser, getUserFromStorage, getWaiverTargets, getWeeklyRankings, getbottomDrawerState, getwebViewState, initialAppState, initialAuthState, initialBettingCartState, initialBottomDrawerState, initialConnectState, initialFeedState, initialSubscriptionsState, initialWebViewState, mergeDraftedPlayerInfo, mockCurrentWeek, mockData, mockDataForFDPlayerProps, mockEventByCurrentWeekWithScore, mockEventByIdWithScore, mockMarketData, mockPaginatedMarket, mockPaginatedPlayerId, mockPaginatedPropBets, mockPaginatedWeek, mutateRankings, nextJsDataProvider, openBetsCartScreen, postThirdPartyAuthorize, postThirdPartyCreate, postThirdPartySettings, removeFromBetsCart, resyncFantasyLeague, setDraftStatusForProvidersWithExtension, setEventsLockoutState, setSelectedEventId, setSportsbookState, signIn, signinWithApple, startLda, startMds, syncFantasyLeague, updateInternetStatus, useAccountStorage, useActivateSubscriptionMutation, useAnswerSurveyMutation, useArticleFeedCategories, useCheckoutMutation, useCompleteMutation, useCreateAccountMutation, useDeleteUserQuery, useGetAppStatusQuery, useGetArticleByIdOrSlugQuery, useGetAvailableMarketsByEventQuery, useGetAvailableMarketsByWeekQuery, useGetBookmarkedArticlesQuery, useGetCurrentEventWeekPlayerPropsAnalysisQuery, useGetCurrentEventWeekQuery, useGetCurrentWeekAndEventsQuery, useGetCurrentWeekEventsQuery, useGetCurrentWeekEventsWithMarketDataQuery, useGetCurrentWeekPlayerPropBetsQuery, useGetEventsWithInsightsQuery, useGetFeedCategoriesQuery, useGetFeedItemsQuery, useGetFunFactsQuery, useGetGameTeamGrading, useGetGameTeamGradingQuery, useGetInsightsByEventQuery, useGetInsightsUpdatedTimestampForCurrentWeekQuery, useGetLandingPageContentQuery, useGetLatestArticlesQuery, useGetLeagueDraftPicksQuery, useGetLeagueDraftersQuery, useGetLeagueKeepersQuery, useGetMatchupsQuery, useGetMdsResultsQuery, useGetMismatchesQuery, useGetMyLeaguesForMdsQuery, useGetNextPickInfoQuery, useGetPlayer, useGetPlayerGradesByIdsQuery, useGetPlayerInsightsByWeekQuery, useGetPlayerMatchupsForEventQuery, useGetPlayerQuery, useGetQuadforceDataQuery, useGetRankingsForMdsQuery, useGetRankingsQuery, useGetSDKEventsByIdQuery, useGetSDKEventsByWeekQuery, useGetSDKEventsQuery, useGetSDKEventsWithMarketByIdQuery, useGetSDKHotPlayersByEventQuery, useGetSDKHotPlayersBySeasonWeekQuery, useGetSDKMismatchesByEventQuery, useGetSDKMismatchesBySeasonWeekQuery, useGetSDKRecentDefensesForEventQuery, useGetStartSitRankingsQuery, useGetTeam, useGetTeamDepthChartQuery, useGetTeams, useGetTeamsQuery, useGetTokenMutation, useGetTopPlayersForEventQuery, useGetUserQuery, useGetWaiverTargetsQuery, useGetWeeklyRankingsQuery, useLazyDeleteUserQuery, useLazyGetAppStatusQuery, useLazyGetDraftBigBoardDataQuery, useLazyGetDraftBigBoardMetadataQuery, useLazyGetPlayersByIdsQuery, useLazyGetUserQuery, usePersistDeviceToBackend, usePostThirdPartyAuthorizeMutation, usePostThirdPartyCreateMutation, usePostThirdPartySettingsMutation, useResyncFantasyLeagueMutation, useSignInMutation, useSigninWithAppleMutation, useUpsertDeviceMutation, webViewActions, webViewAdapter, webViewHooks, webViewReducer, webViewSelectors, webViewSlice, wrapper

// EXTERNAL MODULE: ../../../../../../../../local-cache/custom/dba27c31aad935787bb275c3e5e4e957708f15386de599eff1db476022cd7e4c/node_modules/react/index.js
var react = __webpack_require__(49053);
// EXTERNAL MODULE: ../../../../../../../../local-cache/custom/dba27c31aad935787bb275c3e5e4e957708f15386de599eff1db476022cd7e4c/node_modules/react-redux/es/index.js + 14 modules
var es = __webpack_require__(77206);
// EXTERNAL MODULE: ../../../../../../../../local-cache/custom/dba27c31aad935787bb275c3e5e4e957708f15386de599eff1db476022cd7e4c/node_modules/redux-persist/es/integration/react.js
var integration_react = __webpack_require__(69308);
// EXTERNAL MODULE: ../../libs/data-provider/src/store/store.web.ts
var store_web = __webpack_require__(78588);
// EXTERNAL MODULE: ../../libs/data-provider/src/store/make-store.ts + 8 modules
var make_store = __webpack_require__(25197);
// EXTERNAL MODULE: ../../../../../../../../local-cache/custom/dba27c31aad935787bb275c3e5e4e957708f15386de599eff1db476022cd7e4c/node_modules/next-redux-wrapper/es6/index.js
var es6 = __webpack_require__(23621);
// EXTERNAL MODULE: ../../../../../../../../local-cache/custom/dba27c31aad935787bb275c3e5e4e957708f15386de599eff1db476022cd7e4c/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(19915);
// EXTERNAL MODULE: ../../../../../../../../local-cache/custom/dba27c31aad935787bb275c3e5e4e957708f15386de599eff1db476022cd7e4c/node_modules/redux/es/redux.js + 2 modules
var redux = __webpack_require__(73857);
// EXTERNAL MODULE: ../../../../../../../../local-cache/custom/dba27c31aad935787bb275c3e5e4e957708f15386de599eff1db476022cd7e4c/node_modules/@reduxjs/toolkit/dist/redux-toolkit.esm.js + 1 modules
var redux_toolkit_esm = __webpack_require__(64364);
// EXTERNAL MODULE: ../../libs/data-provider/src/lib/consumer-api/consumer-api.ts + 3 modules
var consumer_api = __webpack_require__(26348);
// EXTERNAL MODULE: ../../../../../../../../local-cache/custom/dba27c31aad935787bb275c3e5e4e957708f15386de599eff1db476022cd7e4c/node_modules/reselect/es/index.js
var reselect_es = __webpack_require__(46398);
;// CONCATENATED MODULE: ../../libs/data-provider/src/lib/simulator/simulator.slice.ts

var SIMULATOR_KEY = 'simulator';
var initialSimulatorState = {
  activeTab: 0,
  selectedTeamId: undefined,
  selectedGameSimulationId: undefined
};
var simulatorSlice = (0,redux_toolkit_esm/* createSlice */.oM)({
  name: SIMULATOR_KEY,
  initialState: initialSimulatorState,
  reducers: {
    updateActiveTab: function updateActiveTab(state, _ref) {
      var payload = _ref.payload;
      state.activeTab = payload;
    },
    setSelectedTeamId: function setSelectedTeamId(state, _ref2) {
      var payload = _ref2.payload;
      state.selectedTeamId = payload;
    },
    setSelectedGameSimulationId: function setSelectedGameSimulationId(state, _ref3) {
      var payload = _ref3.payload;
      state.selectedGameSimulationId = payload;
    }
  }
});
var simulatorReducer = simulatorSlice.reducer;
var simulatorActions = simulatorSlice.actions;
var getSimulatorState = function getSimulatorState(rootState) {
  return rootState[SIMULATOR_KEY];
};
var simulatorSelectors = {
  getActiveTab: (0,reselect_es/* createSelector */.P1)(getSimulatorState, function (state) {
    return state.activeTab;
  }),
  getSelectedTeamId: (0,reselect_es/* createSelector */.P1)(getSimulatorState, function (state) {
    return state.selectedTeamId;
  }),
  getSelectedGameSimulationId: (0,reselect_es/* createSelector */.P1)(getSimulatorState, function (state) {
    return state.selectedGameSimulationId;
  })
};
;// CONCATENATED MODULE: ../../libs/data-provider/src/store/make-store.simulator.ts


var _combineReducers;




var reducers = (0,redux/* combineReducers */.UY)((_combineReducers = {}, (0,defineProperty/* default */.Z)(_combineReducers, consumer_api/* consumerApi.reducerPath */.qi.reducerPath, consumer_api/* consumerApi.reducer */.qi.reducer), (0,defineProperty/* default */.Z)(_combineReducers, SIMULATOR_KEY, simulatorSlice.reducer), _combineReducers));
var devTools = false;
var middlewares = [consumer_api/* consumerApi.middleware */.qi.middleware]; // eslint-disable-next-line no-underscore-dangle

if (false) { var reduxDebugger; }

var makeStore = function makeStore() {
  return (0,redux_toolkit_esm/* configureStore */.xC)({
    reducer: reducers,
    devTools: devTools,
    // Adding the api middleware enables caching, invalidation, polling,
    // and other useful features of `rtk-query`.
    middleware: function middleware(getDefaultMiddleware) {
      return getDefaultMiddleware({}).concat(middlewares);
    }
  });
};
var make_store_simulator_makeTestStore = function makeTestStore(preloadedState) {
  return configureStore({
    reducer: reducers,
    devTools: devTools,
    preloadedState: preloadedState,
    // Adding the api middleware enables caching, invalidation, polling,
    // and other useful features of `rtk-query`.
    middleware: function middleware(getDefaultMiddleware) {
      return getDefaultMiddleware().concat(middlewares);
    }
  });
};
;// CONCATENATED MODULE: ../../libs/data-provider/src/store/store.simulator.ts


var store_simulator_store = makeStore();
var wrapper = (0,es6/* createWrapper */.KV)(makeStore, {
  debug: false
});
var nextJsDataProvider = wrapper.withRedux;
// EXTERNAL MODULE: ../../../../../../../../local-cache/custom/dba27c31aad935787bb275c3e5e4e957708f15386de599eff1db476022cd7e4c/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(260);
;// CONCATENATED MODULE: ../../libs/data-provider/src/data-provider.tsx







var DataProvider = function DataProvider(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_jsx(Provider, {
    store: store,
    children: /*#__PURE__*/_jsx(PersistGate, {
      loading: null,
      persistor: persistor,
      children: children
    })
  });
};
var SimulatorDataProvider = function SimulatorDataProvider(_ref2) {
  var children = _ref2.children;
  return /*#__PURE__*/_jsx(Provider, {
    store: simulatorStore,
    children: children
  });
};
var TestDataProvider = function TestDataProvider(_ref3) {
  var children = _ref3.children,
      modifiedState = _ref3.modifiedState;
  var modifiedStore = makeTestStore(modifiedState);
  return /*#__PURE__*/_jsx(Provider, {
    store: modifiedStore,
    children: children
  });
};
// EXTERNAL MODULE: ../../libs/data-provider/src/lib/fantasy-sync/fantasy-sync-api.ts
var fantasy_sync_api = __webpack_require__(12720);
// EXTERNAL MODULE: ../../libs/data-provider/src/lib/socket/live-draft/live-draft.ts
var live_draft = __webpack_require__(15574);
// EXTERNAL MODULE: ../../libs/data-provider/src/lib/fantasy-lda-mds/fantasy-lda-mds-api.ts + 4 modules
var fantasy_lda_mds_api = __webpack_require__(79100);
// EXTERNAL MODULE: ../../libs/data-provider/src/lib/consumer-api/custom-hooks/use-get-team.ts
var use_get_team = __webpack_require__(48337);
;// CONCATENATED MODULE: ../../libs/data-provider/src/lib/consumer-api/custom-hooks/use-get-teams.ts

var useGetTeams = function useGetTeams() {
  return useGetTeamsQuery();
};
// EXTERNAL MODULE: ../../libs/data-provider/src/lib/fantasy/fantasy.slice.ts + 9 modules
var fantasy_slice = __webpack_require__(99756);
// EXTERNAL MODULE: ../../libs/data-provider/src/lib/fantasy/fantasy.hooks.ts
var fantasy_hooks = __webpack_require__(43576);
// EXTERNAL MODULE: ../../libs/data-provider/src/lib/feed/feed.slice.ts
var feed_slice = __webpack_require__(31664);
// EXTERNAL MODULE: ../../libs/schema/src/index.ts
var src = __webpack_require__(17565);
;// CONCATENATED MODULE: ../../libs/data-provider/src/lib/feed/feed.hooks.ts



var feedHooks = {
  useFeedCategories: function useFeedCategories() {
    return (0,es/* useSelector */.v9)(feed_slice/* feedSelectors.getFeedCategories */.bU.getFeedCategories);
  },
  useFeedArticles: function useFeedArticles(feedCategorySlug) {
    return feedCategorySlug === src.ALL_CATEGORY.slug ? (0,es/* useSelector */.v9)(feed_slice/* feedSelectors.getFeedArticles */.bU.getFeedArticles) : (0,es/* useSelector */.v9)(feed_slice/* feedSelectors.getFeedArticlesByFeedCategory */.bU.getFeedArticlesByFeedCategory(feedCategorySlug));
  },
  useArticles: function useArticles() {
    return (0,es/* useSelector */.v9)(feed_slice/* feedSelectors.getArticles */.bU.getArticles);
  },
  useFeedArticleById: function useFeedArticleById(articleId) {
    return (0,es/* useSelector */.v9)(feed_slice/* feedSelectors.getFeedArticleById */.bU.getFeedArticleById(articleId));
  },
  useBookmarkArticles: function useBookmarkArticles() {
    return (0,es/* useSelector */.v9)(feed_slice/* feedSelectors.getBookmarkFeedArticles */.bU.getBookmarkFeedArticles);
  },
  useBookmarkArticleIds: function useBookmarkArticleIds() {
    return (0,es/* useSelector */.v9)(feed_slice/* feedSelectors.getBookmarkArticleIds */.bU.getBookmarkArticleIds);
  },
  useUnreadArticlesList: function useUnreadArticlesList() {
    return (0,es/* useSelector */.v9)(feed_slice/* feedSelectors.getUnreadArticlesList */.bU.getUnreadArticlesList);
  },
  useFilterCategory: function useFilterCategory() {
    return (0,es/* useSelector */.v9)(feed_slice/* feedSelectors.getFilterCategory */.bU.getFilterCategory);
  },
  useArticleActions: function useArticleActions() {
    var dispatch = (0,es/* useDispatch */.I0)();
    return {
      addBookmarkedArticleId: function addBookmarkedArticleId(payload) {
        dispatch(feed_slice/* feedSlice.actions.addBookmarkedArticleId */.u0.actions.addBookmarkedArticleId(payload));
      },
      addBookmarkedArticles: function addBookmarkedArticles(payload) {
        dispatch(feed_slice/* feedSlice.actions.addBookmarkedArticles */.u0.actions.addBookmarkedArticles(payload));
      },
      removeBookmarkedArticle: function removeBookmarkedArticle(payload) {
        dispatch(feed_slice/* feedSlice.actions.removeBookmarkedArticle */.u0.actions.removeBookmarkedArticle(payload));
      },
      updateUnreadArticlesList: function updateUnreadArticlesList() {
        dispatch(feed_slice/* feedSlice.actions.updateUnreadArticlesList */.u0.actions.updateUnreadArticlesList());
      },
      addFilterCategory: function addFilterCategory(payload) {
        dispatch(feed_slice/* feedSlice.actions.addFilterCategory */.u0.actions.addFilterCategory(payload));
      }
    };
  }
};
// EXTERNAL MODULE: ../../libs/data-provider/src/lib/betting/betting.slice.ts
var betting_slice = __webpack_require__(34946);
;// CONCATENATED MODULE: ../../libs/data-provider/src/lib/betting/betting.hooks.ts


var bettingHooks = {
  useBetsCartState: function useBetsCartState() {
    return (0,es/* useSelector */.v9)(betting_slice/* bettingSelectors.getBetsCartState */.hD.getBetsCartState);
  },
  useBetSlipCount: function useBetSlipCount() {
    return (0,es/* useSelector */.v9)(betting_slice/* bettingSelectors.getBetSlipCount */.hD.getBetSlipCount);
  },
  useCartBetCategoryCount: function useCartBetCategoryCount() {
    return (0,es/* useSelector */.v9)(betting_slice/* bettingSelectors.getCartBetCategoryCount */.hD.getCartBetCategoryCount);
  },
  useCartBetDetailedTypeCount: function useCartBetDetailedTypeCount() {
    return (0,es/* useSelector */.v9)(betting_slice/* bettingSelectors.getCartDetailedBetTypeCount */.hD.getCartDetailedBetTypeCount);
  },
  useCartBetGeneralTypeCount: function useCartBetGeneralTypeCount() {
    return (0,es/* useSelector */.v9)(betting_slice/* bettingSelectors.getCartGeneralBetTypeCount */.hD.getCartGeneralBetTypeCount);
  },
  useCartGameIdCount: function useCartGameIdCount() {
    return (0,es/* useSelector */.v9)(betting_slice/* bettingSelectors.getCartGameIdCount */.hD.getCartGameIdCount);
  },
  useCartTeamCount: function useCartTeamCount() {
    return (0,es/* useSelector */.v9)(betting_slice/* bettingSelectors.getCartTeamCount */.hD.getCartTeamCount);
  },
  useCartGameTimesCount: function useCartGameTimesCount() {
    return (0,es/* useSelector */.v9)(betting_slice/* bettingSelectors.getCartGameTimesCount */.hD.getCartGameTimesCount);
  },
  useLockedEventsState: function useLockedEventsState() {
    return (0,es/* useSelector */.v9)(betting_slice/* bettingSelectors.getLockedEventsState */.hD.getLockedEventsState);
  },
  useSelectedEventId: function useSelectedEventId() {
    return (0,es/* useSelector */.v9)(betting_slice/* bettingSelectors.getSelectedEventId */.hD.getSelectedEventId);
  },
  useSportsbookId: function useSportsbookId() {
    return (0,es/* useSelector */.v9)(betting_slice/* bettingSelectors.getSportsbookId */.hD.getSportsbookId);
  },
  useBettingActions: function useBettingActions() {
    var dispatch = (0,es/* useDispatch */.I0)();
    return {
      addToBetsCart: function addToBetsCart(payload) {
        dispatch((0,betting_slice/* addToBetsCart */.G0)(payload));
      },
      removeFromBetsCart: function removeFromBetsCart(payload) {
        dispatch((0,betting_slice/* removeFromBetsCart */.bQ)(payload));
      },
      clearAllBets: function clearAllBets() {
        dispatch((0,betting_slice/* clearAllBets */.j0)());
      },
      clearBetsCartForSportsbook: function clearBetsCartForSportsbook(payload) {
        dispatch((0,betting_slice/* clearBetsCartForSportsbook */.Q6)(payload));
      },
      openBetsCartScreen: function openBetsCartScreen() {
        dispatch((0,betting_slice/* openBetsCartScreen */.JJ)());
      },
      closeBetsCartScreen: function closeBetsCartScreen() {
        dispatch((0,betting_slice/* closeBetsCartScreen */.sJ)());
      },
      closeBetLimitModal: function closeBetLimitModal() {
        dispatch((0,betting_slice/* closeBetLimitModal */.a4)());
      },
      disableEventsLockout: function disableEventsLockout() {
        dispatch((0,betting_slice/* setEventsLockoutState */.y$)(false));
      },
      enableEventsLockout: function enableEventsLockout() {
        dispatch((0,betting_slice/* setEventsLockoutState */.y$)(true));
      },
      setSelectedEventId: function setSelectedEventId(payload) {
        dispatch((0,betting_slice/* setSelectedEventId */.i3)(payload));
      },
      setSportsbookId: function setSportsbookId(payload) {
        dispatch((0,betting_slice/* setSportsbookState */.BO)(payload));
      }
    };
  }
};
// EXTERNAL MODULE: ../../libs/data-provider/src/lib/connect/connect.hooks.ts
var connect_hooks = __webpack_require__(75579);
// EXTERNAL MODULE: ../../libs/data-provider/src/lib/connect/connect.slice.ts
var connect_slice = __webpack_require__(74736);
// EXTERNAL MODULE: ../../libs/utils/src/index.ts + 64 modules
var utils_src = __webpack_require__(40418);
// EXTERNAL MODULE: ../../../../../../../../local-cache/custom/dba27c31aad935787bb275c3e5e4e957708f15386de599eff1db476022cd7e4c/node_modules/lodash/lodash.js
var lodash = __webpack_require__(24822);
// EXTERNAL MODULE: ../../../../../../../../local-cache/custom/dba27c31aad935787bb275c3e5e4e957708f15386de599eff1db476022cd7e4c/node_modules/jest-chance/dist/index.js
var dist = __webpack_require__(83879);
;// CONCATENATED MODULE: ../../libs/data-provider/src/lib/account/mocks/user.ts
var User = {
  constraints: {},
  email: 'groot-admin@pff.com',
  first_name: 'Groot',
  group_memberships: [],
  groups: [],
  last_name: 'Admin',
  permissions: {},
  preferences: {
    features: ''
  },
  provider: '',
  roles: ['groot-super-admin'],
  subscriptions: [{
    end_date: '3000-12-31',
    id: 3,
    roles: ['groot-super-admin'],
    start_date: '2022-02-22'
  }],
  uid: 'a29064db-fa41-448e-90c6-91a1cae1cb8f',
  vertical: 'PFF',
  message: '',
  channel: '',
  product_id: '',
  original_transaction_id: ''
};
;// CONCATENATED MODULE: ../../libs/data-provider/src/mock-data.ts


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





var mockGames = [];
var mockMismatchs = [];
var mockPlayers = [];
var mockPropBets = [];
var mockBestBets = [];
var mockPropBetsWithPlayer = [];
var mockFDPropBetsWithPlayer = [];
var mockTeams = [];
var mockBets = [];
var mockTeamGrading = [{
  teamId: 2,
  quarterbackName: 'Home QB',
  quarterbackRank: 1,
  offensiveLineRank: 11,
  defensiveLineRank: 21,
  receiverRank: 31,
  coverageRank: 7,
  gameId: 2,
  quarterbackPlayerId: 4,
  runningBackRank: 20
}, {
  teamId: 1,
  quarterbackName: 'Away QB',
  quarterbackRank: 32,
  offensiveLineRank: 2,
  defensiveLineRank: 28,
  receiverRank: 25,
  coverageRank: 14,
  gameId: 2,
  quarterbackPlayerId: 5,
  runningBackRank: 10
}];
var gameId = 1;

var getNextGameId = function getNextGameId() {
  gameId += 1;
  return gameId;
};

var defaultBetProductData = {
  value: 1,
  odds: -110,
  description: 'This bet was mocked.',
  sportsbookId: 'BETMGM',
  sportsbookBetId: 'MOCKED_SPORTSBOOK_BET_ID',
  sportsbookEventId: 'MOCKED_SPORTSBOOK_EVENT_ID',
  updatedTimestamp: Date.now(),
  gameId: 2,
  // type should be one of TypeOfBet
  detailedType: dist.chance.pickone(['AwayTeamMoneyline', 'AwayTeamSpread', 'HomeTeamMoneyline', 'HomeTeamSpread', 'Player', 'Over', 'Under']),
  generalType: dist.chance.pickone(['Spread', 'Moneyline', 'Total']),
  category: dist.chance.pickone(['Game Bet', 'Mismatches Prop', 'General Player Prop']),
  sportsbookMarketId: 'MOCKED_SPORTSBOOK_MARKET_ID',
  sportsbookOptionId: 'MOCKED_SPORTSBOOK_OPTION_ID',
  status: dist.chance.pickone(['winner', 'loser', 'void', undefined]),
  uniqueBetId: 'MOCKED_SPORTSBOOK_UNIQUE_ID'
};
(0,lodash.times)(10, function (i) {
  (0,lodash.times)(10, function (n) {
    var mockGameId = getNextGameId(); // @ts-expect-error

    mockGames.push({
      league: 'nfl',
      weekAbv: i.toString(),
      gameId: mockGameId,
      eventId: mockGameId,
      sportsbookEventId: 'MOCKED SPORTSBOOK EVENT ID',
      season: 2022,
      awayTeamId: 1,
      homeTeamId: 2,
      eventStatus: 'Scheduled',
      homeScore: 21,
      awayScore: 7,
      channel: 'NBC',
      startTimestamp: new Date("Sept ".concat((i + 1) * 3 + Math.floor(n / 5), " 2022 19:30")).getTime(),
      homeMoneyline: _objectSpread(_objectSpread({}, defaultBetProductData), {}, {
        sportsbookBetId: dist.chance.guid(),
        detailedType: 'HomeTeamMoneyline',
        generalType: 'Moneyline'
      }),
      awayMoneyline: _objectSpread(_objectSpread({}, defaultBetProductData), {}, {
        sportsbookBetId: dist.chance.guid(),
        detailedType: 'AwayTeamMoneyline',
        generalType: 'Moneyline',
        category: 'Game Bet'
      }),
      homePointSpread: _objectSpread(_objectSpread({}, defaultBetProductData), {}, {
        sportsbookBetId: dist.chance.guid(),
        detailedType: 'HomeTeamSpread',
        generalType: 'Spread',
        category: 'Game Bet'
      }),
      awayPointSpread: _objectSpread(_objectSpread({}, defaultBetProductData), {}, {
        sportsbookBetId: dist.chance.guid(),
        detailedType: 'AwayTeamSpread',
        generalType: 'Spread',
        category: 'Game Bet'
      }),
      overTotal: _objectSpread(_objectSpread({}, defaultBetProductData), {}, {
        sportsbookBetId: dist.chance.guid(),
        detailedType: 'Over',
        generalType: 'Total',
        category: 'Game Bet'
      }),
      underTotal: _objectSpread(_objectSpread({}, defaultBetProductData), {}, {
        sportsbookBetId: dist.chance.guid(),
        detailedType: 'Under',
        generalType: 'Total',
        category: 'Game Bet'
      })
    });
  });
});
(0,lodash.times)(15, function (i) {
  mockPlayers.push({
    playerId: dist.chance.integer({
      min: 0
    }),
    firstName: dist.chance.first(),
    lastName: dist.chance.last(),
    position: dist.chance.pickone(['QB', 'RB', 'WR', 'TE', 'K']),
    teamId: i + 1,
    height: dist.chance.integer({
      min: 0,
      max: 100
    }),
    weight: dist.chance.integer({
      min: 100,
      max: 400
    }),
    jerseyNumber: dist.chance.integer({
      min: 1,
      max: 99
    }),
    birthDate: dist.chance.date().toISOString()
  });
});
var propBetTypeswithOverAndUnder = ['rush_att', 'rush_yd', 'rush_recv_yd', 'pass_comp', 'pass_int', 'pass_att', 'pass_yd', 'pass_td', 'recv_yd', 'recv_rec', 'pass_rush_yd'];
var propBetTypeswithOnlyOver = ['alt_pass_yd', 'alt_rush_yd', 'alt_recv_yd'];
var propBetTypesWithoutOverOrUnder = ['any_time_td', 'first_td', 'two_plus_td', 'three_plus_td', 'most_pass_yd', 'most_rush_yd', 'first_team_td_scorer', 'first_td_second_half', 'last_td', 'first_half_td', 'second_half_td', 'first_completion', 'longest_pass', 'longest_reception', 'first_reception', 'longest_rush', 'first_rush_att'];
propBetTypeswithOverAndUnder.forEach(function (propKey, ix) {
  var player = mockPlayers[ix];
  var sharedPropData = {
    playerId: player.playerId,
    player: {
      playerId: player.playerId,
      firstName: player.firstName,
      lastName: player.lastName,
      position: player.position,
      teamId: player.teamId
    },
    name: 'MOCKED PROP BET',
    sportsbookId: 'BETMGM',
    sportsbookBetId: 'MOCKED SPORTSBOOK BET ID',
    sportsbookEventId: 'MOCKED SPORTSBOOK EVENT ID',
    sportsbookMarketId: 'MOCKED SPORTSBOOK MARKET ID',
    sportsbookOptionId: 'MOCKED SPORTSBOOK OPTION ID',
    value: 65.5,
    propKey: propKey,
    gameId: 2,
    edge: dist.chance.integer({
      min: 1.0,
      max: 4.0
    })
  };
  mockPropBetsWithPlayer.push(_objectSpread(_objectSpread({}, sharedPropData), {}, {
    odds: dist.chance.integer({
      min: -200,
      max: 200
    }),
    option: 'over',
    sportsradarId: "".concat(dist.chance.integer({
      min: 1,
      max: 10000
    })),
    sportsbookOptionId: "".concat(dist.chance.integer({
      min: 1,
      max: 10000
    })),
    analysisText: 'MOCKED ANALYSIS TEXT'
  }));
  mockPropBetsWithPlayer.push(_objectSpread(_objectSpread({}, sharedPropData), {}, {
    odds: dist.chance.integer({
      min: -200,
      max: 200
    }),
    option: 'under',
    sportsradarId: "".concat(dist.chance.integer({
      min: 1,
      max: 10000
    })),
    sportsbookOptionId: "".concat(dist.chance.integer({
      min: 1,
      max: 10000
    })),
    analysisText: 'MOCKED ANALYSIS TEXT'
  }));
});
(0,lodash.times)(10, function () {
  var propBet = {
    playerId: dist.chance.integer({
      min: 0
    }),
    name: 'MOCKED PROP BET',
    sportsbookId: 'BETMGM',
    sportsbookBetId: 'MOCKED SPORTSBOOK BET ID',
    sportsbookEventId: 'MOCKED SPORTSBOOK EVENT ID',
    sportsbookMarketId: 'MOCKED SPORTSBOOK MARKET ID',
    sportsbookOptionId: 'MOCKED SPORTSBOOK OPTION ID',
    value: 65.5,
    odds: dist.chance.integer({
      min: -200,
      max: 200
    }),
    grade: dist.chance.pickone(['A', 'B', 'C', 'D', 'F']),
    propKey: dist.chance.pickone(propBetTypeswithOverAndUnder),
    option: dist.chance.pickone(['over', 'under']),
    gameId: 2,
    edge: dist.chance.floating({
      min: 1.0,
      max: 4.0
    })
  };
  mockPropBets.push(propBet); // mock data for best bets should have grade as 'A'

  mockBestBets.push(_objectSpread(_objectSpread({}, propBet), {}, {
    grade: 'A',
    edge: dist.chance.floating({
      min: 2.6,
      max: 4.0
    })
  }));
});
(0,lodash.times)(10, function (i) {
  mockMismatchs.push({
    id: dist.chance.string(),
    gameId: dist.chance.integer({
      min: 0
    }),
    offenseHomeTeam: dist.chance.bool(),
    homeTeamId: dist.chance.integer({
      min: 0
    }),
    awayTeamId: dist.chance.integer({
      min: 0
    }),
    mismatchType: dist.chance.pickone(['LWR_RCB', 'RWR_LCB', 'SWR_SCB', 'WR_DB', 'HB_LB', 'TE_LB']),
    offensePlayerIds: [dist.chance.integer({
      min: 0
    })],
    defensePlayerIds: [dist.chance.integer({
      min: 0
    })],
    description: dist.chance.sentence({
      words: 3
    }),
    spread: (3 - i * 0.3) * dist.chance.pickone([-1, 1]),
    gradeDifference: dist.chance.floating({
      min: 0,
      max: 50
    }),
    active: true,
    bets: mockPropBetsWithPlayer,
    insight: 'test insight'
  });
});
(0,lodash.times)(10, function (i) {
  mockTeams.push({
    teamId: i + 1,
    teamAbv: Object.keys(utils_src/* TEAM_CONFERENCE_DIVISION_INFO */.sW)[i],
    name: i === 0 ? 'Dolphins' : dist.chance.name(),
    city: dist.chance.city(),
    byeWeek: dist.chance.integer({
      min: 4,
      max: 15
    }),
    fullName: i === 0 ? 'Miami Dolphins' : dist.chance.name(),
    headCoach: dist.chance.name(),
    colors: [dist.chance.string()],
    stadiumDetails: {
      name: dist.chance.name(),
      city: dist.chance.city(),
      state: dist.chance.state(),
      country: dist.chance.country(),
      capacity: dist.chance.integer({
        min: 0
      }),
      stadiumType: dist.chance.pickone(['Outdoor', 'Dome', 'RetractableDome'])
    },
    season: dist.chance.integer({
      min: 2000,
      max: 2050
    }),
    league: 'nfl',
    conference: dist.chance.pickone(['AFC', 'NFC']),
    division: dist.chance.pickone(['North', 'East', 'West', 'South'])
  });
});
(0,lodash.times)(10, function (i) {
  mockBets.push(_objectSpread(_objectSpread({}, defaultBetProductData), {}, {
    sportsbookBetId: "id".concat(i + 1)
  }));
}); // Mocking data for FD player props.

propBetTypeswithOverAndUnder.forEach(function (propKey, ix) {
  var player = mockPlayers[ix];
  var sharedPropData = {
    playerId: player.playerId,
    player: {
      playerId: player.playerId,
      firstName: player.firstName,
      lastName: player.lastName,
      position: player.position,
      teamId: player.teamId
    },
    name: 'MOCKED PROP BET',
    sportsbookId: 'FD',
    sportsbookBetId: 'MOCKED SPORTSBOOK BET ID',
    sportsbookEventId: 'MOCKED SPORTSBOOK EVENT ID',
    sportsbookMarketId: 'MOCKED SPORTSBOOK MARKET ID',
    sportsbookOptionId: 'MOCKED SPORTSBOOK OPTION ID',
    value: 65.5,
    propKey: propKey,
    gameId: 2
  };
  mockFDPropBetsWithPlayer.push(_objectSpread(_objectSpread({}, sharedPropData), {}, {
    odds: -200,
    option: 'over',
    sportsradarId: '9999',
    sportsbookOptionId: '9999',
    analysisText: 'MOCKED ANALYSIS TEXT'
  }));
  mockFDPropBetsWithPlayer.push(_objectSpread(_objectSpread({}, sharedPropData), {}, {
    odds: +200,
    option: 'under',
    sportsradarId: '9999',
    sportsbookOptionId: '9999',
    analysisText: 'MOCKED ANALYSIS TEXT'
  }));
});
propBetTypeswithOnlyOver.forEach(function (propKey, ix) {
  var player = mockPlayers[ix];
  var sharedPropData = {
    playerId: player.playerId,
    player: {
      playerId: player.playerId,
      firstName: player.firstName,
      lastName: player.lastName,
      position: player.position,
      teamId: player.teamId
    },
    name: 'MOCKED PROP BET',
    sportsbookId: 'FD',
    sportsbookBetId: 'MOCKED SPORTSBOOK BET ID',
    sportsbookEventId: 'MOCKED SPORTSBOOK EVENT ID',
    sportsbookMarketId: 'MOCKED SPORTSBOOK MARKET ID',
    sportsbookOptionId: 'MOCKED SPORTSBOOK OPTION ID',
    value: 65.5,
    propKey: propKey,
    gameId: 2
  };
  mockFDPropBetsWithPlayer.push(_objectSpread(_objectSpread({}, sharedPropData), {}, {
    odds: -110,
    option: 'over',
    sportsradarId: '9999',
    sportsbookOptionId: '9999',
    analysisText: 'MOCKED ANALYSIS TEXT'
  }));
});
propBetTypesWithoutOverOrUnder.forEach(function (propKey, ix) {
  var player = mockPlayers[ix % 15];
  var sharedPropData = {
    playerId: player.playerId,
    player: {
      playerId: player.playerId,
      firstName: player.firstName,
      lastName: player.lastName,
      position: player.position,
      teamId: player.teamId
    },
    name: 'MOCKED PROP BET',
    sportsbookId: 'FD',
    sportsbookBetId: 'MOCKED SPORTSBOOK BET ID',
    sportsbookEventId: 'MOCKED SPORTSBOOK EVENT ID',
    sportsbookMarketId: 'MOCKED SPORTSBOOK MARKET ID',
    sportsbookOptionId: 'MOCKED SPORTSBOOK OPTION ID',
    value: 65.5,
    propKey: propKey,
    gameId: 2
  };
  mockFDPropBetsWithPlayer.push(_objectSpread(_objectSpread({}, sharedPropData), {}, {
    odds: -200,
    option: 'over',
    sportsradarId: '9999',
    sportsbookOptionId: '9999',
    analysisText: 'MOCKED ANALYSIS TEXT'
  }));
});
var mockData = {
  games: mockGames,
  mismatches: mockMismatchs,
  players: mockPlayers,
  propBets: mockPropBets,
  bestBets: mockBestBets,
  propBetsWithPlayer: mockPropBetsWithPlayer,
  teams: mockTeams,
  bets: mockBets,
  teamGrading: mockTeamGrading,
  user: User
};
var mockDataForFDPlayerProps = {
  propBetsWithPlayer: mockFDPropBetsWithPlayer
};
var MOCK_ERROR_ID = 999999999;
var MOCK_EMPTY_ID = 101010101;
var mockCurrentWeek = {
  weekType: 'POST',
  abbreviation: 'WC',
  description: 'Wild Card'
};
var mockEventByCurrentWeekWithScore = {
  season: 2022,
  week: 'WC',
  events: [{
    eventId: 23637,
    eventStatus: 'Final',
    startTimestamp: 1673731800000,
    sportradarId: 'f5b7bedd-ad2b-4304-8861-ef778c7348be',
    sportsbookEventId: '32014055',
    weekAbv: 'WC',
    homeTeam: '49ers',
    awayTeam: 'Seahawks',
    homeTeamId: 28,
    awayTeamId: 29,
    homeTeamAbbreviation: 'SF',
    awayTeamAbbreviation: 'SEA',
    homeScore: 41,
    awayScore: 23
  }, {
    eventId: 23641,
    eventStatus: 'Final',
    startTimestamp: 1673831700000,
    sportradarId: 'bef2d032-4f28-4b29-bbaf-b8d3ddb84f5a',
    sportsbookEventId: '32013579',
    weekAbv: 'WC',
    homeTeam: 'Bengals',
    awayTeam: 'Ravens',
    homeTeamId: 7,
    awayTeamId: 3,
    homeTeamAbbreviation: 'CIN',
    awayTeamAbbreviation: 'BAL',
    homeScore: 24,
    awayScore: 17
  }, {
    eventId: 23642,
    eventStatus: 'Final',
    startTimestamp: 1673918100000,
    sportradarId: '910a1bd3-3818-46e4-a9dd-de8caf8c70e8',
    sportsbookEventId: '32013698',
    weekAbv: 'WC',
    homeTeam: 'Buccaneers',
    awayTeam: 'Cowboys',
    homeTeamId: 30,
    awayTeamId: 9,
    homeTeamAbbreviation: 'TB',
    awayTeamAbbreviation: 'DAL',
    homeScore: 14,
    awayScore: 31
  }, {
    eventId: 23640,
    eventStatus: 'Final',
    startTimestamp: 1673819400000,
    sportradarId: '5a63395a-facd-4098-bf86-63ae39cff218',
    sportsbookEventId: '32013702',
    weekAbv: 'WC',
    homeTeam: 'Vikings',
    awayTeam: 'Giants',
    homeTeamId: 18,
    awayTeamId: 21,
    homeTeamAbbreviation: 'MIN',
    awayTeamAbbreviation: 'NYG',
    homeScore: 24,
    awayScore: 31
  }, {
    eventId: 23639,
    eventStatus: 'Final',
    startTimestamp: 1673805600000,
    sportradarId: '741b54b9-0a51-4bb9-a2a2-9543041cfb44',
    sportsbookEventId: '32013584',
    weekAbv: 'WC',
    homeTeam: 'Bills',
    awayTeam: 'Dolphins',
    homeTeamId: 4,
    awayTeamId: 17,
    homeTeamAbbreviation: 'BUF',
    awayTeamAbbreviation: 'MIA',
    homeScore: 34,
    awayScore: 31
  }, {
    eventId: 23638,
    eventStatus: 'Final',
    startTimestamp: 1673745300000,
    sportradarId: 'efeba152-4733-4450-9e05-81f2c1e29821',
    sportsbookEventId: '32013582',
    weekAbv: 'WC',
    homeTeam: 'Jaguars',
    awayTeam: 'Chargers',
    homeTeamId: 15,
    awayTeamId: 27,
    homeTeamAbbreviation: 'JAX',
    awayTeamAbbreviation: 'LAC',
    homeScore: 31,
    awayScore: 30
  }]
};
var mockEventByIdWithScore = {
  event: {
    season: 2022,
    eventId: 23637,
    eventStatus: 'Final',
    startTimestamp: 1673731800000,
    sportradarId: 'f5b7bedd-ad2b-4304-8861-ef778c7348be',
    sportsbookEventId: '32014055',
    weekAbv: 'WC',
    homeTeam: '49ers',
    awayTeam: 'Seahawks',
    homeTeamId: 28,
    awayTeamId: 29,
    homeTeamAbbreviation: 'SF',
    awayTeamAbbreviation: 'SEA',
    homeScore: 41,
    awayScore: 23
  }
};
var mockMarketData = {
  markets: [{
    eventId: 23637,
    market: 'moneyline',
    value: null,
    odds: 390,
    option: 'away',
    sportsbookBetId: '32014055-357833258-50213',
    sportsbookEventId: '32014055',
    sportsbookMarketId: '357833258',
    sportsbookOptionId: '50213',
    status: null,
    uniqueBetId: '23637+moneyline+away'
  }, {
    eventId: 23637,
    market: 'moneyline',
    value: null,
    odds: -510,
    option: 'home',
    sportsbookBetId: '32014055-357833258-43010249',
    sportsbookEventId: '32014055',
    sportsbookMarketId: '357833258',
    sportsbookOptionId: '43010249',
    status: null,
    uniqueBetId: '23637+moneyline+home'
  }, {
    eventId: 23637,
    market: 'handicap-points',
    value: 9.5,
    odds: -108,
    option: 'away',
    sportsbookBetId: '32014055-357833259-50213',
    sportsbookEventId: '32014055',
    sportsbookMarketId: '357833259',
    sportsbookOptionId: '50213',
    status: null,
    uniqueBetId: '23637+handicap-points+away'
  }, {
    eventId: 23637,
    market: 'handicap-points',
    value: -9.5,
    odds: -112,
    option: 'home',
    sportsbookBetId: '32014055-357833259-43010249',
    sportsbookEventId: '32014055',
    sportsbookMarketId: '357833259',
    sportsbookOptionId: '43010249',
    status: null,
    uniqueBetId: '23637+handicap-points+home'
  }, {
    eventId: 23637,
    market: 'total-points',
    value: 42.5,
    odds: -118,
    option: 'under',
    sportsbookBetId: '32014055-357833261-7017917',
    sportsbookEventId: '32014055',
    sportsbookMarketId: '357833261',
    sportsbookOptionId: '7017917',
    status: null,
    uniqueBetId: '23637+total-points+under'
  }, {
    eventId: 23637,
    market: 'total-points',
    value: 42.5,
    odds: -104,
    option: 'over',
    sportsbookBetId: '32014055-357833261-7017916',
    sportsbookEventId: '32014055',
    sportsbookMarketId: '357833261',
    sportsbookOptionId: '7017916',
    status: null,
    uniqueBetId: '23637+total-points+over'
  }]
};
var mockPaginatedMarket = 'alt_pass_yd';
var mockPaginatedWeek = 'SB';
var mockPaginatedPlayerId = 'SB';
var mockPaginatedPropBets = {
  nextPage: 2,
  eventId: mockEventByIdWithScore.event.eventId,
  total: 14,
  playerProps: [{
    eventId: mockEventByIdWithScore.event.eventId,
    playerId: 40291,
    teamId: 24,
    odds: 640,
    value: 325,
    name: 'jalen hurts 325+ yards alt passing yds',
    option: 'over',
    marketType: 'total',
    market: 'alt_pass_yd',
    sportsbookBetId: '32052129-361532748-40905807',
    sportsbookEventId: '32052129',
    sportsbookMarketId: '361532748',
    sportsbookOptionId: '40905807',
    status: 'winner'
  }, {
    eventId: mockEventByIdWithScore.event.eventId,
    playerId: 11765,
    teamId: 16,
    odds: -1450,
    value: 200,
    name: 'patrick mahomes 200+ yards alt passing yds',
    option: 'over',
    marketType: 'total',
    market: 'alt_pass_yd',
    sportsbookBetId: '32052129-361532749-38245772',
    sportsbookEventId: '32052129',
    sportsbookMarketId: '361532749',
    sportsbookOptionId: '38245772',
    status: 'winner'
  }, {
    eventId: mockEventByIdWithScore.event.eventId,
    playerId: 11765,
    teamId: 16,
    odds: -650,
    value: 225,
    name: 'patrick mahomes 225+ yards alt passing yds',
    option: 'over',
    marketType: 'total',
    market: 'alt_pass_yd',
    sportsbookBetId: '32052129-361532749-38245774',
    sportsbookEventId: '32052129',
    sportsbookMarketId: '361532749',
    sportsbookOptionId: '38245774',
    status: 'winner'
  }, {
    eventId: mockEventByIdWithScore.event.eventId,
    playerId: 11765,
    teamId: 16,
    odds: -320,
    value: 250,
    name: 'patrick mahomes 250+ yards alt passing yds',
    option: 'over',
    marketType: 'total',
    market: 'alt_pass_yd',
    sportsbookBetId: '32052129-361532749-38245771',
    sportsbookEventId: '32052129',
    sportsbookMarketId: '361532749',
    sportsbookOptionId: '38245771',
    status: 'winner'
  }, {
    eventId: mockEventByIdWithScore.event.eventId,
    playerId: 11765,
    teamId: 16,
    odds: -174,
    value: 275,
    name: 'patrick mahomes 275+ yards alt passing yds',
    option: 'over',
    marketType: 'total',
    market: 'alt_pass_yd',
    sportsbookBetId: '32052129-361532749-38245770',
    sportsbookEventId: '32052129',
    sportsbookMarketId: '361532749',
    sportsbookOptionId: '38245770',
    status: 'winner'
  }]
};
// EXTERNAL MODULE: ../../libs/data-provider/src/lib/consumer-api/custom-hooks/use-get-player.ts
var use_get_player = __webpack_require__(13661);
// EXTERNAL MODULE: ../../libs/data-provider/src/lib/web-view/web-view.slice.ts
var web_view_slice = __webpack_require__(87323);
;// CONCATENATED MODULE: ../../libs/data-provider/src/lib/web-view/web-view.hooks.ts


var webViewHooks = {
  useActiveUrl: function useActiveUrl() {
    return (0,es/* useSelector */.v9)(web_view_slice/* webViewSelectors.getUrl */.XH.getUrl);
  },
  useIsOpen: function useIsOpen() {
    return (0,es/* useSelector */.v9)(web_view_slice/* webViewSelectors.getIsOpen */.XH.getIsOpen);
  },
  useHasShownFooter: function useHasShownFooter() {
    return (0,es/* useSelector */.v9)(web_view_slice/* webViewSelectors.getHasShownFooter */.XH.getHasShownFooter);
  },
  useHasShownShareButton: function useHasShownShareButton() {
    return (0,es/* useSelector */.v9)(web_view_slice/* webViewSelectors.getHasShownShareButton */.XH.getHasShownShareButton);
  },
  useShareableUrl: function useShareableUrl() {
    return (0,es/* useSelector */.v9)(web_view_slice/* webViewSelectors.getShareableUrl */.XH.getShareableUrl);
  },
  useWebViewActions: function useWebViewActions() {
    var dispatch = (0,es/* useDispatch */.I0)();
    return {
      openWebView: function openWebView(payload) {
        dispatch(web_view_slice/* webViewSlice.actions.openWebView */.R7.actions.openWebView(payload));
      },
      closeWebView: function closeWebView() {
        dispatch(web_view_slice/* webViewSlice.actions.closeWebView */.R7.actions.closeWebView());
      }
    };
  }
};
;// CONCATENATED MODULE: ../../libs/data-provider/src/lib/consumer-api/custom-hooks/use-get-team-grading.ts

var useGetGameTeamGrading = function useGetGameTeamGrading(gameId) {
  var _useGetGameTeamGradin = useGetGameTeamGradingQuery({
    id: gameId
  }),
      _useGetGameTeamGradin2 = _useGetGameTeamGradin.data,
      data = _useGetGameTeamGradin2 === void 0 ? [] : _useGetGameTeamGradin2,
      isLoading = _useGetGameTeamGradin.isLoading;

  return {
    data: data,
    isLoading: isLoading
  };
};
// EXTERNAL MODULE: ../../libs/data-provider/src/lib/subscription-plans/subscription-plans.slice.ts
var subscription_plans_slice = __webpack_require__(73175);
;// CONCATENATED MODULE: ../../libs/data-provider/src/lib/subscription-plans/subscription-plans.hooks.ts


var SubscriptionsHooks = {
  useIsOpen: function useIsOpen() {
    return (0,es/* useSelector */.v9)(subscription_plans_slice/* SubscriptionsSelectors.getIsOpen */.d.getIsOpen);
  },
  useSubscriptionsActions: function useSubscriptionsActions() {
    var dispatch = (0,es/* useDispatch */.I0)();
    return {
      open: function open() {
        // eslint-disable-next-line no-console
        console.log('open');
        dispatch(subscription_plans_slice/* SubscriptionsSlice.actions.open */.e3.actions.open());
      },
      close: function close() {
        dispatch(subscription_plans_slice/* SubscriptionsSlice.actions.close */.e3.actions.close());
      }
    };
  }
};
// EXTERNAL MODULE: ../../../../../../../../local-cache/custom/dba27c31aad935787bb275c3e5e4e957708f15386de599eff1db476022cd7e4c/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(82148);
// EXTERNAL MODULE: ../../../../../../../../local-cache/custom/dba27c31aad935787bb275c3e5e4e957708f15386de599eff1db476022cd7e4c/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(95268);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ../../libs/data-provider/src/lib/account/account.slice.ts
var account_slice = __webpack_require__(19380);
// EXTERNAL MODULE: ../../../../../../../../local-cache/custom/dba27c31aad935787bb275c3e5e4e957708f15386de599eff1db476022cd7e4c/node_modules/@react-native-async-storage/async-storage/lib/module/index.js + 3 modules
var lib_module = __webpack_require__(89225);
// EXTERNAL MODULE: ../../libs/api-sdk/src/index.ts + 6 modules
var api_sdk_src = __webpack_require__(15049);
;// CONCATENATED MODULE: ../../libs/data-provider/src/lib/account/account-api.ts

 // Define a service using a base URL and expected endpoints

var accountApi = consumer_api/* consumerApi.injectEndpoints */.qi.injectEndpoints({
  overrideExisting: true,
  endpoints: function endpoints(builder) {
    return {
      getUser: builder.query({
        query: function query() {
          return {
            url: api_sdk_src/* accountEndpoints.user */.kk.user().url,
            method: 'get',
            headers: {
              'Content-type': 'application/json'
            }
          };
        },
        keepUnusedDataFor: 0
      }),
      deleteUser: builder.query({
        query: function query() {
          return {
            url: api_sdk_src/* accountEndpoints.user */.kk.user().url,
            method: 'delete',
            headers: {
              'Content-type': 'application/json'
            }
          };
        }
      }),
      signIn: builder.mutation({
        query: function query(params) {
          return {
            url: api_sdk_src/* accountEndpoints.signIn */.kk.signIn().url,
            method: 'post',
            body: {
              email: params.email,
              password: params.password
            },
            headers: {
              'Content-type': 'application/json'
            }
          };
        }
      }),
      createAccount: builder.mutation({
        query: function query(params) {
          return {
            url: api_sdk_src/* accountEndpoints.createAccount */.kk.createAccount().url,
            method: 'post',
            body: {
              email: params.email,
              password: params.password
            },
            headers: {
              'Content-type': 'application/json'
            }
          };
        }
      }),
      getAppStatus: builder.query({
        query: function query(params) {
          return {
            url: api_sdk_src/* accountEndpoints.appUser */.kk.appUser({
              uid: params.uid
            }).url,
            method: 'get',
            headers: {
              'Content-type': 'application/json'
            }
          };
        }
      }),
      signinWithApple: builder.mutation({
        query: function query(params) {
          return {
            url: api_sdk_src/* accountEndpoints.apple */.kk.apple().url,
            method: 'post',
            body: {
              id_token: params.idToken,
              first_name: params.firstName,
              last_name: params.lastName,
              nonce: params.nonce,
              client_id: params.clientId
            },
            headers: {
              'Content-type': 'application/json'
            }
          };
        }
      }),
      upsertDevice: builder.mutation({
        query: function query(params) {
          return {
            url: api_sdk_src/* accountEndpoints.device */.kk.device().url,
            method: 'post',
            body: {
              deviceId: params.deviceId,
              systemName: params.systemName
            },
            headers: {
              'Content-type': 'application/json'
            }
          };
        }
      }),
      answerSurvey: builder.mutation({
        query: function query(params) {
          return {
            url: api_sdk_src/* accountEndpoints.answerSurvey */.kk.answerSurvey({
              surveyId: params.surveyId
            }).url,
            method: 'post',
            body: {
              deviceId: params.deviceId,
              answers: params.answers
            },
            headers: {
              'Content-type': 'application/json'
            }
          };
        }
      }),
      activateSubscription: builder.mutation({
        query: function query(params) {
          return {
            url: api_sdk_src/* accountEndpoints.activateSubscription */.kk.activateSubscription().url,
            method: 'post',
            body: {
              groot_uid: params.grootUid,
              product_id: params.productId,
              start_date: params.startDate,
              expiry_date: params.expiryDate,
              original_transaction_id: params.transactionId
            }
          };
        }
      }),
      checkout: builder.mutation({
        query: function query(params) {
          return {
            url: api_sdk_src/* accountEndpoints.checkout */.kk.checkout().url,
            method: 'post',
            body: {
              planCode: params.planCode,
              email: params.email,
              recurlyToken: params.recurlyToken,
              recaptchaToken: params.recaptchaToken,
              promoCode: params.promoCode,
              paymentType: params.paymentType
            }
          };
        }
      }),
      complete: builder.mutation({
        query: function query(body) {
          return {
            url: api_sdk_src/* accountEndpoints.complete */.kk.complete().url,
            method: 'post',
            body: body
          };
        }
      })
    };
  }
}); // Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints

var useGetUserQuery = accountApi.useGetUserQuery,
    useSignInMutation = accountApi.useSignInMutation,
    useCreateAccountMutation = accountApi.useCreateAccountMutation,
    useGetAppStatusQuery = accountApi.useGetAppStatusQuery,
    useLazyGetAppStatusQuery = accountApi.useLazyGetAppStatusQuery,
    useLazyGetUserQuery = accountApi.useLazyGetUserQuery,
    useDeleteUserQuery = accountApi.useDeleteUserQuery,
    useLazyDeleteUserQuery = accountApi.useLazyDeleteUserQuery,
    useSigninWithAppleMutation = accountApi.useSigninWithAppleMutation,
    account_api_useUpsertDeviceMutation = accountApi.useUpsertDeviceMutation,
    useAnswerSurveyMutation = accountApi.useAnswerSurveyMutation,
    useActivateSubscriptionMutation = accountApi.useActivateSubscriptionMutation,
    useCheckoutMutation = accountApi.useCheckoutMutation,
    useCompleteMutation = accountApi.useCompleteMutation; // Export getters to be used when rendering components on the server


var _accountApi$endpoints = accountApi.endpoints,
    getUser = _accountApi$endpoints.getUser,
    signIn = _accountApi$endpoints.signIn,
    createAccount = _accountApi$endpoints.createAccount,
    getAppStatus = _accountApi$endpoints.getAppStatus,
    signinWithApple = _accountApi$endpoints.signinWithApple,
    activateSubscription = _accountApi$endpoints.activateSubscription;

;// CONCATENATED MODULE: ../../libs/data-provider/src/lib/account/account-storage.ts





function account_storage_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function account_storage_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? account_storage_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : account_storage_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







var saveTokenToStorage = /*#__PURE__*/function () {
  var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee(user, token, isPremium, isExpired) {
    return regenerator_default().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!token) {
              _context.next = 11;
              break;
            }

            _context.prev = 1;
            _context.next = 4;
            return lib_module/* default.setItem */.Z.setItem('@user_token', token);

          case 4:
            _context.next = 6;
            return lib_module/* default.setItem */.Z.setItem('@user', JSON.stringify(account_storage_objectSpread(account_storage_objectSpread({}, user), {}, {
              isPremium: isPremium,
              isExpired: isExpired
            })));

          case 6:
            _context.next = 11;
            break;

          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](1);
            // eslint-disable-next-line no-console
            console.log('Could not save token', _context.t0);

          case 11:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[1, 8]]);
  }));

  return function saveTokenToStorage(_x, _x2, _x3, _x4) {
    return _ref.apply(this, arguments);
  };
}();

var updateTokenInStorage = /*#__PURE__*/function () {
  var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(token) {
    return regenerator_default().wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            _context2.next = 3;
            return lib_module/* default.setItem */.Z.setItem('@user_token', token);

          case 3:
            _context2.next = 8;
            break;

          case 5:
            _context2.prev = 5;
            _context2.t0 = _context2["catch"](0);
            // eslint-disable-next-line no-console
            console.log('Could not save token', _context2.t0);

          case 8:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[0, 5]]);
  }));

  return function updateTokenInStorage(_x5) {
    return _ref2.apply(this, arguments);
  };
}();

var getTokenFromStorage = /*#__PURE__*/function () {
  var _ref3 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3() {
    var tok;
    return regenerator_default().wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            _context3.next = 3;
            return lib_module/* default.getItem */.Z.getItem('@user_token');

          case 3:
            tok = _context3.sent;

            if (!tok) {
              _context3.next = 6;
              break;
            }

            return _context3.abrupt("return", tok);

          case 6:
            _context3.next = 12;
            break;

          case 8:
            _context3.prev = 8;
            _context3.t0 = _context3["catch"](0);
            // eslint-disable-next-line no-console
            console.log('Could get token', _context3.t0);
            return _context3.abrupt("return", null);

          case 12:
            return _context3.abrupt("return", null);

          case 13:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[0, 8]]);
  }));

  return function getTokenFromStorage() {
    return _ref3.apply(this, arguments);
  };
}();

var isUser = function isUser(data) {
  if (typeof data === 'object' && data !== null) {
    var maybeUser = data;
    if (typeof maybeUser.uid === 'string') return true;
  }

  return false;
};

var getUserFromStorage = /*#__PURE__*/function () {
  var _ref4 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee4() {
    var userString, userData;
    return regenerator_default().wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.prev = 0;
            _context4.next = 3;
            return lib_module/* default.getItem */.Z.getItem('@user');

          case 3:
            userString = _context4.sent;

            if (!userString) {
              _context4.next = 7;
              break;
            }

            userData = JSON.parse(userString);
            return _context4.abrupt("return", isUser(userData) ? userData : null);

          case 7:
            _context4.next = 13;
            break;

          case 9:
            _context4.prev = 9;
            _context4.t0 = _context4["catch"](0);
            // eslint-disable-next-line no-console
            console.log('Could user', _context4.t0);
            return _context4.abrupt("return", null);

          case 13:
            return _context4.abrupt("return", null);

          case 14:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[0, 9]]);
  }));

  return function getUserFromStorage() {
    return _ref4.apply(this, arguments);
  };
}();

var removeTokenFromStorage = /*#__PURE__*/function () {
  var _ref5 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee5() {
    return regenerator_default().wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.prev = 0;
            _context5.next = 3;
            return lib_module/* default.removeItem */.Z.removeItem('@user_token');

          case 3:
            _context5.next = 5;
            return lib_module/* default.removeItem */.Z.removeItem('@user');

          case 5:
            _context5.next = 10;
            break;

          case 7:
            _context5.prev = 7;
            _context5.t0 = _context5["catch"](0);
            // eslint-disable-next-line no-console
            console.log('Could delete token', _context5.t0);

          case 10:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, null, [[0, 7]]);
  }));

  return function removeTokenFromStorage() {
    return _ref5.apply(this, arguments);
  };
}();

var useAccountStorage = function useAccountStorage() {
  var _useState = (0,react.useState)(),
      user = _useState[0],
      setUser = _useState[1];

  var _useState2 = (0,react.useState)(),
      token = _useState2[0],
      setToken = _useState2[1];

  var _useState3 = (0,react.useState)(),
      uniqueDeviceId = _useState3[0],
      setUniqueDeviceId = _useState3[1];

  var _useState4 = (0,react.useState)(false),
      isReady = _useState4[0],
      setIsReady = _useState4[1];

  (0,react.useEffect)(function () {
    var init = /*#__PURE__*/function () {
      var _ref6 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee6() {
        var storedUser, storedToken, storedUniqueDeviceId;
        return regenerator_default().wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return getUserFromStorage();

              case 2:
                storedUser = _context6.sent;
                _context6.next = 5;
                return getTokenFromStorage();

              case 5:
                storedToken = _context6.sent;
                _context6.next = 8;
                return (0,utils_src/* getUniqueDeviceIdFromStorage */.qU)();

              case 8:
                storedUniqueDeviceId = _context6.sent;

                if (storedUser && storedToken) {
                  setUser(storedUser);
                  setToken(storedToken);
                }

                if (storedUniqueDeviceId) {
                  setUniqueDeviceId(storedUniqueDeviceId);
                }

                setIsReady(true);

              case 12:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      return function init() {
        return _ref6.apply(this, arguments);
      };
    }();

    init();
  }, []);
  return {
    getTokenFromStorage: getTokenFromStorage,
    getUserFromStorage: getUserFromStorage,
    isReady: isReady,
    removeTokenFromStorage: removeTokenFromStorage,
    saveTokenToStorage: saveTokenToStorage,
    updateTokenInStorage: updateTokenInStorage,
    token: token,
    uniqueDeviceId: uniqueDeviceId,
    user: user
  };
};
var upsertDeviceDebounced = (0,lodash.debounce)( /*#__PURE__*/function () {
  var _ref7 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee7(upsertDevice) {
    var deviceSavedStatus, _savedDevice$data, savedDevice;

    return regenerator_default().wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            _context7.next = 2;
            return lib_module/* default.getItem */.Z.getItem('@device_id_persisted');

          case 2:
            deviceSavedStatus = _context7.sent;

            if (!(deviceSavedStatus !== 'true')) {
              _context7.next = 10;
              break;
            }

            _context7.next = 6;
            return upsertDevice();

          case 6:
            savedDevice = _context7.sent;

            if (!(savedDevice !== null && savedDevice !== void 0 && (_savedDevice$data = savedDevice.data) !== null && _savedDevice$data !== void 0 && _savedDevice$data.userId)) {
              _context7.next = 10;
              break;
            }

            _context7.next = 10;
            return lib_module/* default.setItem */.Z.setItem('@device_id_persisted', 'true');

          case 10:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));

  return function (_x6) {
    return _ref7.apply(this, arguments);
  };
}(), 3000);
var usePersistDeviceToBackend = function usePersistDeviceToBackend() {
  var _useUpsertDeviceMutat = useUpsertDeviceMutation(),
      _useUpsertDeviceMutat2 = _slicedToArray(_useUpsertDeviceMutat, 2),
      upsertDeviceMutation = _useUpsertDeviceMutat2[0],
      isLoading = _useUpsertDeviceMutat2[1].isLoading;

  function upsertDevice(_x7) {
    return _upsertDevice.apply(this, arguments);
  }

  function _upsertDevice() {
    _upsertDevice = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(_ref8) {
      var deviceId, systemName;
      return _regeneratorRuntime.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              deviceId = _ref8.deviceId, systemName = _ref8.systemName;

              if (!isLoading) {
                upsertDeviceDebounced(function () {
                  return upsertDeviceMutation({
                    deviceId: deviceId,
                    systemName: systemName
                  });
                });
              }

            case 2:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8);
    }));
    return _upsertDevice.apply(this, arguments);
  }

  return {
    upsertDevice: upsertDevice
  };
};
// EXTERNAL MODULE: ../../libs/data-provider/src/lib/account/util/checkHasCurrentSubscription.ts
var checkHasCurrentSubscription = __webpack_require__(47451);
// EXTERNAL MODULE: ../../libs/data-provider/src/lib/account/util/checkHasExpiredSubscription.ts
var checkHasExpiredSubscription = __webpack_require__(3981);
;// CONCATENATED MODULE: ../../libs/data-provider/src/lib/account/account.hooks.ts








var accountHooks = {
  getIsLoading: function getIsLoading() {
    return (0,es/* useSelector */.v9)(account_slice/* accountSelectors.getLoadingState */.sH.getLoadingState);
  },
  getToken: function getToken() {
    return (0,es/* useSelector */.v9)(account_slice/* accountSelectors.getToken */.sH.getToken);
  },
  getUser: function getUser() {
    return (0,es/* useSelector */.v9)(account_slice/* accountSelectors.getUser */.sH.getUser);
  },
  getError: function getError() {
    return (0,es/* useSelector */.v9)(account_slice/* accountSelectors.getError */.sH.getError);
  },
  getIsPremium: function getIsPremium() {
    return (0,es/* useSelector */.v9)(account_slice/* accountSelectors.getIsPremium */.sH.getIsPremium);
  },
  getIsExpired: function getIsExpired() {
    return (0,es/* useSelector */.v9)(account_slice/* accountSelectors.getIsExpired */.sH.getIsExpired);
  },
  getSubscriptionType: function getSubscriptionType() {
    return (0,es/* useSelector */.v9)(account_slice/* accountSelectors.getSubscriptionType */.sH.getSubscriptionType);
  },
  getLoginRedirect: function getLoginRedirect() {
    return (0,es/* useSelector */.v9)(account_slice/* accountSelectors.getLoginRedirect */.sH.getLoginRedirect);
  },
  getIsLoggedIn: function getIsLoggedIn() {
    return (0,es/* useSelector */.v9)(account_slice/* accountSelectors.getIsLoggedIn */.sH.getIsLoggedIn);
  },
  getIsCreatingAccount: function getIsCreatingAccount() {
    return (0,es/* useSelector */.v9)(account_slice/* accountSelectors.getIsCreatingAccount */.sH.getIsCreatingAccount);
  },
  useAccountActions: function useAccountActions() {
    var dispatch = (0,es/* useDispatch */.I0)();

    var _useAccountStorage = useAccountStorage(),
        saveTokenToStorage = _useAccountStorage.saveTokenToStorage,
        removeTokenFromStorage = _useAccountStorage.removeTokenFromStorage;

    var signOut = /*#__PURE__*/function () {
      var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
        return regenerator_default().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return removeTokenFromStorage();

              case 2:
                dispatch(account_slice/* accountActions.deleteToken */.$h.deleteToken());
                dispatch(account_slice/* accountActions.updateError */.$h.updateError({
                  error: null
                }));
                dispatch(account_slice/* accountActions.updateUser */.$h.updateUser({
                  user: null,
                  token: null
                }));
                dispatch(account_slice/* accountActions.setIsLoggedIn */.$h.setIsLoggedIn({
                  isLoggedIn: false
                }));
                consumer_api/* consumerApi.util.resetApiState */.qi.util.resetApiState();

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function signOut() {
        return _ref.apply(this, arguments);
      };
    }();

    var setError = function setError(e) {
      dispatch(account_slice/* accountActions.updateLoading */.$h.updateLoading({
        loading: false
      }));
      dispatch(account_slice/* accountActions.updateError */.$h.updateError({
        error: e
      }));
      dispatch(account_slice/* accountActions.setIsLoggedIn */.$h.setIsLoggedIn({
        isLoggedIn: false
      }));
    };

    var startLoading = function startLoading() {
      dispatch(account_slice/* accountSlice.actions.updateLoading */.Nx.actions.updateLoading({
        loading: true
      }));
    };

    var endLoading = function endLoading() {
      dispatch(account_slice/* accountActions.updateLoading */.$h.updateLoading({
        loading: false
      }));
    };

    var updateUser = /*#__PURE__*/function () {
      var _ref2 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(user, token) {
        var isPremiumUser, isSubscriptionExpired;
        return regenerator_default().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                isPremiumUser = (0,checkHasCurrentSubscription/* checkHasCurrentSubscription */.E)(user);
                isSubscriptionExpired = !isPremiumUser && (0,checkHasExpiredSubscription/* checkHasExpiredSubscription */.A)(user);
                _context2.next = 4;
                return saveTokenToStorage(user, token, isPremiumUser, isSubscriptionExpired);

              case 4:
                dispatch(account_slice/* accountActions.updateUser */.$h.updateUser({
                  user: user,
                  token: token
                }));

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function updateUser(_x, _x2) {
        return _ref2.apply(this, arguments);
      };
    }();

    var clearError = function clearError() {
      dispatch(account_slice/* accountActions.updateError */.$h.updateError({
        error: null
      }));
    };

    var setLoggedIn = function setLoggedIn(loggedIn) {
      dispatch(account_slice/* accountActions.setIsLoggedIn */.$h.setIsLoggedIn({
        isLoggedIn: loggedIn
      }));
    };

    var resetErrors = function resetErrors() {
      dispatch(account_slice/* accountActions.resetError */.$h.resetError());
    };

    var setRedirectScreen = function setRedirectScreen(payload) {
      dispatch(account_slice/* accountActions.setRedirectScreen */.$h.setRedirectScreen(payload));
    };

    var setCreatingAccount = function setCreatingAccount(payload) {
      dispatch(account_slice/* accountActions.setIsCreatingAccount */.$h.setIsCreatingAccount({
        isCreatingAccount: payload
      }));
    };

    return {
      signOut: signOut,
      clearError: clearError,
      resetErrors: resetErrors,
      setRedirectScreen: setRedirectScreen,
      startLoading: startLoading,
      endLoading: endLoading,
      updateUser: updateUser,
      setError: setError,
      setLoggedIn: setLoggedIn,
      setCreatingAccount: setCreatingAccount
    };
  }
};
// EXTERNAL MODULE: ../../libs/data-provider/src/lib/app/app.slice.ts
var app_slice = __webpack_require__(50100);
;// CONCATENATED MODULE: ../../libs/data-provider/src/lib/app/app.hooks.ts


var appHooks = {
  useInternetStatus: function useInternetStatus() {
    return (0,es/* useSelector */.v9)(app_slice/* appSelectors.getInternetStatus */.LL.getInternetStatus);
  },
  useAppActions: function useAppActions() {
    var dispatch = (0,es/* useDispatch */.I0)();
    return {
      updateInternetStatus: function updateInternetStatus(payload) {
        dispatch((0,app_slice/* updateInternetStatus */.gq)(payload));
      }
    };
  }
};
// EXTERNAL MODULE: ../../libs/data-provider/src/lib/bottom-drawer/bottom-drawer.slice.ts
var bottom_drawer_slice = __webpack_require__(52493);
;// CONCATENATED MODULE: ../../libs/data-provider/src/lib/bottom-drawer/bottom-drawer.hooks.ts


var bottomDrawerHooks = {
  useIsOpen: function useIsOpen() {
    return (0,es/* useSelector */.v9)(bottom_drawer_slice/* bottomDrawerSelectors.getIsOpen */.Si.getIsOpen);
  },
  useSubscriptionWorkflow: function useSubscriptionWorkflow() {
    return (0,es/* useSelector */.v9)(bottom_drawer_slice/* bottomDrawerSelectors.getSubscriptionWorkflow */.Si.getSubscriptionWorkflow);
  },
  useBottomDrawerActions: function useBottomDrawerActions() {
    var dispatch = (0,es/* useDispatch */.I0)();
    return {
      openBottomDrawer: function openBottomDrawer() {
        var payload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        dispatch(bottom_drawer_slice/* bottomDrawerSlice.actions.openBottomDrawer */.Fk.actions.openBottomDrawer(payload));
      },
      closeBottomDrawer: function closeBottomDrawer() {
        dispatch(bottom_drawer_slice/* bottomDrawerSlice.actions.closeBottomDrawer */.Fk.actions.closeBottomDrawer());
      }
    };
  }
};
;// CONCATENATED MODULE: ../../libs/data-provider/src/lib/consumer-api/custom-hooks/use-article-feed-categories.ts


 // Converts a list of slugs to a list of full Feed Category objects that can be used downstream

var useArticleFeedCategories = function useArticleFeedCategories(feedCategories) {
  var _useGetFeedCategories = useGetFeedCategoriesQuery(),
      data = _useGetFeedCategories.data;

  return useMemo(function () {
    return filter(data, function (d) {
      return includes(feedCategories, d === null || d === void 0 ? void 0 : d.slug);
    });
  }, [data, feedCategories]);
};
// EXTERNAL MODULE: ../../libs/data-provider/src/lib/fantasy/utils/get-cheatsheet-players-from-rankings.ts
var get_cheatsheet_players_from_rankings = __webpack_require__(395);
// EXTERNAL MODULE: ../../libs/data-provider/src/lib/fantasy/utils/merge-drafted-player-info.ts
var merge_drafted_player_info = __webpack_require__(90741);
;// CONCATENATED MODULE: ../../libs/data-provider/src/index.ts




































/***/ }),

/***/ 53656:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Y": function() { return /* binding */ ProgressPane; }
});

// EXTERNAL MODULE: ../../../../../../../../local-cache/custom/dba27c31aad935787bb275c3e5e4e957708f15386de599eff1db476022cd7e4c/node_modules/react/index.js
var react = __webpack_require__(49053);
// EXTERNAL MODULE: ../../../../../../../../local-cache/custom/dba27c31aad935787bb275c3e5e4e957708f15386de599eff1db476022cd7e4c/node_modules/react-native-web/dist/cjs/exports/View/index.js
var View = __webpack_require__(90998);
var View_default = /*#__PURE__*/__webpack_require__.n(View);
// EXTERNAL MODULE: ../../../../../../../../local-cache/custom/dba27c31aad935787bb275c3e5e4e957708f15386de599eff1db476022cd7e4c/node_modules/react-native-reanimated/lib/reanimated2/hook/useSharedValue.js
var useSharedValue = __webpack_require__(51234);
// EXTERNAL MODULE: ../../../../../../../../local-cache/custom/dba27c31aad935787bb275c3e5e4e957708f15386de599eff1db476022cd7e4c/node_modules/react-native-reanimated/lib/reanimated2/hook/useAnimatedStyle.js + 3 modules
var useAnimatedStyle = __webpack_require__(3245);
// EXTERNAL MODULE: ../../../../../../../../local-cache/custom/dba27c31aad935787bb275c3e5e4e957708f15386de599eff1db476022cd7e4c/node_modules/react-native-reanimated/lib/reanimated2/animation/repeat.js
var repeat = __webpack_require__(1538);
// EXTERNAL MODULE: ../../../../../../../../local-cache/custom/dba27c31aad935787bb275c3e5e4e957708f15386de599eff1db476022cd7e4c/node_modules/react-native-reanimated/lib/reanimated2/animation/timing.js
var timing = __webpack_require__(65668);
// EXTERNAL MODULE: ../../../../../../../../local-cache/custom/dba27c31aad935787bb275c3e5e4e957708f15386de599eff1db476022cd7e4c/node_modules/react-native-reanimated/lib/reanimated2/Easing.js + 3 modules
var Easing = __webpack_require__(5133);
// EXTERNAL MODULE: ../../../../../../../../local-cache/custom/dba27c31aad935787bb275c3e5e4e957708f15386de599eff1db476022cd7e4c/node_modules/react-native-reanimated/lib/reanimated2/component/View.js + 23 modules
var component_View = __webpack_require__(38765);
// EXTERNAL MODULE: ../../libs/tweed-ui/src/styles/use-dimensions.ts
var use_dimensions = __webpack_require__(33217);
// EXTERNAL MODULE: ../../libs/tweed-ui/src/atoms/icon/icon.web.tsx
var icon_web = __webpack_require__(48793);
// EXTERNAL MODULE: ../../libs/tweed-ui/src/atoms/browser-text/index.ts + 4 modules
var browser_text = __webpack_require__(37456);
// EXTERNAL MODULE: ../../libs/tweed-ui/src/styles/theme.ts + 1 modules
var styles_theme = __webpack_require__(89821);
// EXTERNAL MODULE: ../../libs/schema/src/index.ts
var src = __webpack_require__(17565);
// EXTERNAL MODULE: ../../libs/utils/src/lib/svg/svg-group.ts
var svg_group = __webpack_require__(37710);
// EXTERNAL MODULE: ../../libs/tweed-ui/src/styles/create-use-styles.ts
var create_use_styles = __webpack_require__(28854);
;// CONCATENATED MODULE: ../../libs/feature-fantasy/src/lib/progress-pane/progress-pane.styles.ts

var useStyles = (0,create_use_styles/* createUseStyles */.Q)(function (theme, props) {
  return {
    container: {
      maxWidth: theme.calcUnit(295),
      margin: 'auto',
      marginTop: theme.calcUnit(props.isDesktop ? theme.spacing.s16 : theme.spacing.s10),
      display: 'flex',
      flexDirection: 'column',
      textAlign: 'center'
    },
    iconContainer: {
      marginTop: theme.calcUnit(theme.spacing.s12),
      padding: theme.calcUnit(theme.spacing.s2),
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    header: {
      marginTop: theme.calcUnit(theme.spacing.s1)
    },
    message: {
      marginTop: theme.calcUnit(theme.spacing.s2)
    }
  };
});
// EXTERNAL MODULE: ../../../../../../../../local-cache/custom/dba27c31aad935787bb275c3e5e4e957708f15386de599eff1db476022cd7e4c/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(260);
;// CONCATENATED MODULE: ../../libs/feature-fantasy/src/lib/progress-pane/progress-pane.web.tsx












var ProgressPane = function ProgressPane(props) {
  var children = props.children,
      header = props.header,
      message = props.message,
      state = props.state;
  var theme = (0,styles_theme/* useTheme */.Fg)();

  var _useBreakpoints = (0,use_dimensions/* useBreakpoints */.kC)(),
      isDesktop = _useBreakpoints.isDesktop;

  var styles = useStyles({
    isDesktop: isDesktop
  });
  var spinValue = (0,useSharedValue/* useSharedValue */.y)(0);
  var spinStyle = (0,useAnimatedStyle/* useAnimatedStyle */.l)(function () {
    var _f = function _f() {
      return {
        transform: [{
          rotate: "".concat(spinValue.value, "deg")
        }]
      };
    };

    _f._closure = {
      spinValue: spinValue
    };
    _f.asString = "function _f(){const{spinValue}=jsThis._closure;{return{transform:[{rotate:spinValue.value+\"deg\"}]};}}";
    _f.__workletHash = 4715244457197;
    _f.__location = "/codebuild/output/src423867346/src/github.com/pro-football-focus/voodoo/libs/feature-fantasy/src/lib/progress-pane/progress-pane.web.tsx (22:37)";
    _f.__optimalization = 3;
    return _f;
  }());
  (0,react.useEffect)(function () {
    spinValue.value = (0,repeat/* withRepeat */.DQ)((0,timing/* withTiming */.j)(360, {
      duration: 800,
      easing: Easing/* Easing.linear */.o.linear
    }), -1, // -1 means repeat indefinitely
    false);
  }, []);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)((View_default()), {
    style: styles.container,
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(component_View/* default */.Z, {
      style: [styles.iconContainer, state === src.CurrentProgressState.IN_PROGRESS ? spinStyle : {}],
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(icon_web/* Icon */.J, {
        group: svg_group/* SVGGroup.Icons */.O.Icons,
        testID: "fantasySync.progressState.icon",
        name: state,
        width: "92",
        height: "92"
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
      style: styles.header,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(browser_text/* Text */.x, {
        variant: browser_text/* TextDescriptionVariant.MODAL_HEADER */.c.MODAL_HEADER,
        colorOverride: theme.colors.webModalHeaderColor,
        children: header
      })
    }), /*#__PURE__*/(0,jsx_runtime.jsx)((View_default()), {
      style: styles.message,
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(browser_text/* Text */.x, {
        variant: browser_text/* TextDescriptionVariant.MODAL_DESCRIPTION */.c.MODAL_DESCRIPTION,
        colorOverride: theme.colors.webModalDescriptionColor,
        children: message
      })
    }), children]
  }, state);
};

/***/ }),

/***/ 48793:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ Icon; }
/* harmony export */ });
/* harmony import */ var _codebuild_local_cache_custom_dba27c31aad935787bb275c3e5e4e957708f15386de599eff1db476022cd7e4c_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19915);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(49053);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(260);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_codebuild_local_cache_custom_dba27c31aad935787bb275c3e5e4e957708f15386de599eff1db476022cd7e4c_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }





// TODO: Bring this in dynamically, maybe from secrets, especially if they move to S3 bucket
// Process.env cannot be destructure https://github.com/vercel/next.js/issues/15574#issuecomment-754251494
var ENV = "production";
var SVG_PATH = undefined;
var ICON_SYMBOL_PATH = SVG_PATH === 'assets' || ENV === 'development' ? '/assets/svg' : '/voodoo-assets/svg';

var buildHref = function buildHref(group, name) {
  return "".concat(ICON_SYMBOL_PATH, "/").concat(group, "-symbols.svg#").concat(String(name));
};

var Icon = function Icon(props) {
  var name = props.name,
      _props$focusable = props.focusable,
      focusable = _props$focusable === void 0 ? false : _props$focusable,
      group = props.group,
      className = props.className,
      fill = props.fill,
      height = props.height,
      width = props.width,
      testID = props.testID,
      style = props.style;
  var href = buildHref(group, name);

  if (!name) {
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.Fragment, {});
  }

  if (name === 'projection-gradient') {
    /* Web unable to display projection-gradient svg due to way its exported so give fallback classname to display it */
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
      style: {
        background: 'linear-gradient(90deg, #EE0033 0%, #3388FF 99.24%)',
        width: width,
        height: height,
        minWidth: '132px'
      },
      className: className
    });
  } // TODO: Fix


  if (name === 'sleeper-long-icon') {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("svg", {
      className: className,
      focusable: focusable,
      "data-testid": testID,
      height: height,
      width: width,
      style: _objectSpread({}, style),
      viewBox: "0 0 229 56",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        d: "M164.809 38.5439V48.875H158.604V17.4189C158.837 17.5463 159.054 17.6312 159.236 17.7628C160.836 18.8875 162.436 20.0039 164.02 21.1499C164.385 21.413 164.588 21.4003 164.877 21.048C166.125 19.5327 167.831 18.8833 169.729 18.6711C172.008 18.4122 174.24 18.5395 176.316 19.6643C179.563 21.4215 181.363 24.172 181.855 27.7671C182.118 29.6856 182.135 31.6253 181.562 33.5014C180.017 38.5481 176.1 41.3368 171.074 41.2434C168.829 41.2009 166.864 40.4794 165.242 38.9046C165.14 38.807 165.03 38.7264 164.813 38.5439H164.809ZM164.784 30.2119C164.937 30.908 165.021 31.6296 165.246 32.3002C166.019 34.5752 167.95 35.9632 170.297 36.0014C172.678 36.0396 174.648 34.7323 175.476 32.487C176.121 30.734 176.138 28.9343 175.497 27.1856C174.771 25.2076 173.332 23.9555 171.197 23.6711C169.011 23.3825 167.199 24.0871 165.921 25.9377C165.034 27.2195 164.796 28.6711 164.784 30.2076V30.2119Z",
        fill: "#022047"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        d: "M138.111 31.6082C138.6 33.4885 139.669 34.7874 141.397 35.4283C144.232 36.4767 146.902 36.1414 149.296 34.2059C149.406 34.1167 149.512 34.0276 149.622 33.9427C149.635 33.9342 149.656 33.9342 149.737 33.9172C149.843 34.0191 149.992 34.1337 150.119 34.2738C151.019 35.2627 151.902 36.2645 152.814 37.2364C153.069 37.5081 153.052 37.6609 152.802 37.9198C151.07 39.6983 148.905 40.6236 146.499 40.9716C144.122 41.3154 141.723 41.2475 139.44 40.4241C135.153 38.8791 132.458 35.874 131.855 31.3493C131.172 26.2262 133.472 21.5445 138.239 19.5666C142.055 17.9834 145.968 17.9749 149.622 20.2032C152.381 21.8883 153.948 24.4308 154.398 27.6057C154.559 28.7389 154.491 29.9062 154.546 31.0564C154.567 31.5148 154.385 31.6549 153.926 31.6549C149.355 31.6294 144.784 31.621 140.217 31.6082C139.533 31.6082 138.85 31.6082 138.111 31.6082ZM138.472 27.2194H149.007C148.752 25.3518 146.24 23.4842 143.952 23.4206C141.443 23.3527 138.88 25.0929 138.472 27.2194Z",
        fill: "#022047"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        d: "M111.658 31.6167C112.282 33.8536 113.679 35.2118 115.818 35.7212C118.428 36.3409 120.86 35.9461 122.936 34.1125C122.987 34.0658 123.046 34.0234 123.106 33.9852C123.148 33.9597 123.203 33.9427 123.318 33.896C123.742 34.3545 124.188 34.8214 124.621 35.301C125.164 35.8995 125.674 36.5319 126.238 37.1091C126.582 37.4572 126.539 37.6864 126.217 38.0132C124.693 39.554 122.834 40.4665 120.716 40.8401C117.499 41.4088 114.328 41.2857 111.387 39.7407C106.917 37.3935 104.523 32.8392 105.495 27.6227C106.221 23.7347 108.364 20.8187 112.1 19.4435C116.357 17.8773 120.58 18.0301 124.303 21.0055C126.633 22.8688 127.809 25.3985 128.059 28.34C128.14 29.278 128.068 30.2288 128.08 31.1753C128.084 31.5403 127.94 31.6422 127.571 31.6422C122.592 31.6252 117.618 31.6252 112.639 31.621C112.342 31.621 112.044 31.621 111.658 31.621V31.6167ZM111.87 27.003H122.414C121.781 24.6345 119.039 22.9197 116.459 23.2381C114.273 23.5097 111.917 25.4283 111.87 27.003Z",
        fill: "#022047"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        d: "M191.311 31.6166C191.824 33.4884 192.881 34.817 194.642 35.4452C197.486 36.4596 200.156 36.1455 202.525 34.1633C202.745 33.9808 202.915 33.8195 203.178 34.1124C204.18 35.2414 205.199 36.362 206.311 37.5929C205.665 38.1489 205.092 38.7432 204.422 39.2016C202.605 40.4579 200.534 40.9885 198.348 41.0946C195.759 41.2177 193.238 40.9376 190.912 39.6854C186.468 37.2958 184.201 32.5801 185.135 27.6438C185.873 23.7346 188.013 20.7931 191.773 19.4306C196.298 17.7965 200.721 18.0469 204.485 21.4765C206.506 23.3186 207.52 25.704 207.716 28.4163C207.779 29.3203 207.72 30.2372 207.737 31.1455C207.745 31.536 207.588 31.6378 207.198 31.6378C202.202 31.6209 197.21 31.6209 192.215 31.6166C191.934 31.6166 191.659 31.6166 191.315 31.6166H191.311ZM202.232 27.2193C201.867 25.1565 199.273 23.4035 196.799 23.4077C194.176 23.4162 192.032 25.4791 191.663 27.2193H202.232Z",
        fill: "#022047"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        d: "M91.2682 20.6827C90.2962 21.8796 89.3921 23.0002 88.4668 24.0995C88.3777 24.2056 88.106 24.2778 87.9872 24.2226C86.4804 23.5138 84.859 23.3949 83.2376 23.3567C82.3462 23.3355 81.4294 23.3822 80.5635 23.5732C79.9948 23.7005 79.4175 24.0528 78.9931 24.4603C78.2842 25.1394 78.4752 26.26 79.3963 26.5826C80.6145 27.0113 81.9048 27.2574 83.1697 27.5461C84.5067 27.8517 85.8734 28.0554 87.1935 28.4247C89.494 29.0656 91.1748 30.4153 91.595 32.8814C92.1001 35.8441 90.7376 38.3908 88.0381 39.749C86.3573 40.5937 84.5661 41.0096 82.6985 41.0903C79.6 41.2304 76.5779 40.8314 73.6917 39.6429C73.2205 39.4477 72.7833 39.1803 72.3377 38.9341C72.0618 38.7813 72.0915 38.6115 72.308 38.3993C73.3564 37.3806 74.3963 36.3577 75.4277 35.3262C75.6569 35.097 75.8352 35.0801 76.1577 35.1692C77.5627 35.5427 78.9718 35.9587 80.4107 36.1497C81.4931 36.294 82.6221 36.1624 83.7214 36.0648C84.1374 36.0308 84.5746 35.8186 84.9311 35.5809C86.005 34.8551 85.8904 33.5138 84.6765 33.0639C83.8106 32.7413 82.8768 32.5885 81.9685 32.3933C80.2834 32.0325 78.5431 31.85 76.9133 31.3152C74.6042 30.5597 72.9149 29.0571 72.6221 26.4849C72.3165 23.8279 73.2842 21.7099 75.5593 20.2285C77.2443 19.1292 79.1416 18.6963 81.1196 18.5732C84.2945 18.3779 87.3929 18.6665 90.2835 20.1309C90.6103 20.2964 90.9201 20.4832 91.2809 20.6869L91.2682 20.6827Z",
        fill: "#022047"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        d: "M211.527 18.0046C213.462 19.3926 215.288 20.6999 217.168 22.0454C218.093 20.5471 219.451 19.4775 221.179 18.9851C222.232 18.6838 223.348 18.6031 224.498 18.4121V24.4775C224.32 24.4648 224.154 24.452 223.989 24.4393C222.159 24.3035 220.47 24.6006 219.125 25.9716C218.102 27.0072 217.703 28.3188 217.677 29.711C217.609 33.1618 217.614 36.6168 217.601 40.0676C217.597 41.3749 217.665 41.099 216.582 41.1117C215.084 41.133 213.581 41.1075 212.083 41.1287C211.659 41.1372 211.506 41.0396 211.51 40.5812C211.531 33.3231 211.531 26.065 211.535 18.8069C211.535 18.6031 211.535 18.3994 211.535 18.0089L211.527 18.0046Z",
        fill: "#022047"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        d: "M95.4871 11.0647C95.9752 11.3236 96.3827 11.5189 96.7732 11.7438C98.1314 12.5206 99.4854 13.3143 100.848 14.0825C101.209 14.2863 101.366 14.5197 101.366 14.9527C101.353 23.4374 101.357 31.9222 101.357 40.407C101.357 40.8852 101.121 41.1243 100.648 41.1243C99.0949 41.1243 97.5415 41.1073 95.9922 41.1243C95.5805 41.1286 95.4489 41.0182 95.4489 40.5895C95.4616 30.895 95.4574 21.2006 95.4574 11.5061C95.4574 11.4043 95.4744 11.3024 95.4914 11.0647L95.4871 11.0647Z",
        fill: "#022047"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("rect", {
        x: "5.5",
        y: "3",
        width: "50.9341",
        height: "50.9341",
        rx: "12",
        fill: "url(#paint0_linear_5309_3548)"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        d: "M30.1639 18.0892C30.1639 17.2241 30.1827 16.3914 30.1461 15.5598C30.1399 15.4229 29.9152 15.2505 29.7543 15.1721C28.7597 14.6842 28.0524 13.9654 27.8476 12.8454C27.5561 11.248 28.814 9.64006 30.5254 9.39767C32.22 9.15841 33.7924 10.3557 33.9522 12.0044C34.0901 13.4326 33.4466 14.562 32.1719 15.1983C32.0194 15.2745 31.8637 15.5096 31.8543 15.6789C31.8178 16.3559 31.8543 17.0371 31.8313 17.7151C31.8199 18.0578 31.9525 18.1487 32.2764 18.1842C36.2299 18.6157 39.5857 20.2654 42.2478 23.2263C44.6309 25.878 45.9306 28.9695 45.8585 32.5875C45.8167 34.675 45.9306 36.7698 45.4448 38.8269C44.7302 41.8505 43.3239 44.4217 40.5876 46.0818C39.0863 46.9929 37.4 47.3721 35.6782 47.5821C32.431 47.9781 29.1787 47.9593 25.9294 47.6124C21.4975 47.1392 18.8145 44.5366 17.3069 40.5027C16.3634 37.9827 16.1597 35.352 16.1137 32.6972C15.9988 26.1078 20.3409 19.3314 28.5748 18.2657C29.0888 18.1989 29.6049 18.1508 30.1639 18.0892ZM31.6704 39.6962C32.1312 39.6763 32.8615 39.6554 33.5907 39.6105C36.9716 39.3984 40.2836 38.7799 43.5537 37.9117C43.8504 37.8333 43.9831 37.6986 43.9737 37.3715C43.9507 36.6068 43.9675 35.8409 43.9654 35.0751C43.9591 33.2833 43.4733 31.6901 42.1422 30.4008C40.783 29.0854 39.1772 28.2162 37.3843 27.6896C33.6106 26.5811 29.793 26.5539 25.9775 27.4159C23.6163 27.9487 21.4651 28.9486 19.7736 30.755C19.0349 31.5438 18.4373 32.4277 18.3903 33.5487C18.337 34.8338 18.3527 36.122 18.3255 37.4081C18.3193 37.7017 18.4196 37.8406 18.7121 37.9127C22.8818 38.9345 27.0954 39.6293 31.6694 39.6972L31.6704 39.6962ZM26.7506 41.5151C26.7506 41.6353 26.736 41.6917 26.7527 41.7366C27.2793 43.1178 27.7996 44.5021 28.3522 45.8729C28.4087 46.0129 28.6604 46.156 28.8224 46.1571C30.3363 46.1696 31.8512 46.1435 33.3651 46.1497C33.7621 46.1518 33.9491 45.9909 34.0661 45.619C34.2427 45.0559 34.4757 44.5105 34.6878 43.9589C34.9866 43.1847 35.2885 42.4115 35.6239 41.5465C32.616 41.91 29.701 41.8599 26.7496 41.5151H26.7506ZM26.8352 45.9889C26.2648 44.4812 25.7079 42.9883 25.1228 41.5068C25.0727 41.3793 24.8397 41.2821 24.6746 41.2487C22.9225 40.8914 21.1673 40.5508 19.4142 40.2029C19.1896 40.158 18.9691 40.0974 18.6954 40.0315C20.226 43.8398 23.073 45.8781 26.8342 45.9889H26.8352ZM43.5485 40.0869C41.8633 40.438 40.2293 40.8736 38.567 41.0909C37.5045 41.2299 36.9685 41.6489 36.6875 42.6717C36.3855 43.7687 35.906 44.8166 35.4975 45.9042C39.2419 45.713 42.1704 43.6245 43.5485 40.0869ZM32.2848 12.3972C32.2848 11.6502 31.7091 11.0693 30.9746 11.0745C30.2537 11.0798 29.6655 11.691 29.6791 12.4212C29.6916 13.138 30.2621 13.7042 30.9746 13.7105C31.7258 13.7168 32.2858 13.1557 32.2858 12.3972H32.2848Z",
        fill: "white"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        d: "M31.6717 39.6975C27.0977 39.6296 22.8831 38.9359 18.7144 37.9131C18.4229 37.842 18.3216 37.702 18.3278 37.4084C18.355 36.1223 18.3393 34.8341 18.3926 33.549C18.4386 32.428 19.0362 31.5441 19.7759 30.7553C21.4674 28.9489 23.6186 27.949 25.9798 27.4162C29.7953 26.5542 33.6129 26.5814 37.3867 27.6899C39.1795 28.2165 40.7853 29.0857 42.1446 30.4011C43.4756 31.6893 43.9604 33.2836 43.9677 35.0754C43.9708 35.8413 43.9541 36.6071 43.9761 37.3719C43.9855 37.6989 43.8528 37.8336 43.5561 37.912C40.2859 38.7802 36.974 39.3987 33.5931 39.6108C32.8638 39.6568 32.1335 39.6766 31.6728 39.6965L31.6717 39.6975ZM28.0767 35.2217C26.1167 35.0733 24.1556 35.0598 22.1099 35.1214C22.5122 35.5978 27.5261 35.6866 28.0767 35.2217ZM33.9567 35.1747C33.9462 35.2322 33.9358 35.2886 33.9253 35.346C34.0517 35.392 34.1771 35.4766 34.3035 35.4777C35.9689 35.4913 37.6332 35.4986 39.2986 35.4913C39.4637 35.4913 39.6287 35.3774 39.7938 35.3168C39.7781 35.2698 39.7625 35.2228 39.7468 35.1757H33.9567V35.1747ZM40.1668 34.7401C40.1428 34.692 40.1198 34.645 40.0958 34.5969C38.1859 34.5969 36.2761 34.5938 34.3662 34.6042C34.2419 34.6042 34.1186 34.7108 33.9619 34.7829C34.0517 34.8613 34.0758 34.8999 34.0998 34.901C35.9929 34.9187 37.8871 34.9386 39.7802 34.9407C39.9087 34.9407 40.0373 34.8101 40.1647 34.7401H40.1668ZM21.8153 34.6795C22.1904 35.0619 27.0956 35.1486 27.9189 34.8226C27.6431 34.5489 22.7431 34.4214 21.8153 34.6795ZM22.6574 35.6981C22.6459 35.7483 22.6334 35.7974 22.6219 35.8475C22.8246 35.9113 23.0273 36.0272 23.2299 36.0293C24.6164 36.046 26.0038 36.045 27.3902 36.0325C27.5511 36.0314 27.711 35.9175 27.8719 35.8559C27.7026 35.7848 27.5334 35.6553 27.3631 35.6532C25.9244 35.6375 24.4858 35.6448 23.0471 35.649C22.9175 35.649 22.787 35.6814 22.6574 35.6981ZM39.3456 35.8528L39.2871 35.6532C37.5465 35.5926 35.8059 35.5989 34.058 35.7869C34.2105 35.9447 34.3735 36.022 34.5365 36.0231C35.9449 36.0356 37.3543 36.0408 38.7626 36.0283C38.957 36.0262 39.1513 35.9144 39.3446 35.8528H39.3456ZM27.7214 36.2247H23.3971C23.9508 36.6823 27.1875 36.7147 27.7214 36.2247ZM38.5777 36.2456H34.3537C34.8384 36.721 38.1075 36.6875 38.5777 36.2456ZM21.6617 33.992C21.6565 34.0547 21.6513 34.1163 21.6461 34.179C21.8937 34.4454 25.9673 34.5489 26.8208 34.3096C26.8229 34.2636 26.824 34.2166 26.8261 34.1707C25.1043 34.1111 23.3835 34.0526 21.6617 33.9931V33.992ZM35.1916 34.3838C36.8329 34.3838 38.4743 34.3859 40.1146 34.3754C40.1898 34.3754 40.264 34.2532 40.3381 34.1874C40.3214 34.1414 40.3047 34.0954 40.288 34.0495C38.5861 34.0631 36.8778 33.8948 35.1905 34.3838H35.1916ZM40.4541 33.8217C40.0028 33.3672 37.9749 33.4445 37.4734 33.8217H40.4541ZM21.5364 33.8008H24.3625C23.9205 33.4675 22.018 33.3829 21.5364 33.8008ZM22.9959 33.2669C22.5738 33.1039 22.1413 32.8135 21.6816 33.2669H22.9959ZM40.2525 33.2816C40.2567 33.2345 40.2608 33.1865 40.265 33.1395C39.8084 32.8396 39.3822 33.0548 38.8138 33.2816H40.2535H40.2525ZM37.091 36.908C37.091 36.8651 37.091 36.8223 37.091 36.7795H35.2678C35.2678 36.8223 35.2678 36.8651 35.2678 36.908H37.091ZM26.6526 36.9048C26.6505 36.862 26.6484 36.8202 26.6464 36.7774H24.8243C24.8243 36.8202 24.8243 36.862 24.8243 36.9048H26.6526Z",
        fill: "#00042B"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        d: "M26.7512 41.5159C29.7027 41.8606 32.6176 41.9108 35.6255 41.5472C35.2891 42.4123 34.9872 43.1854 34.6894 43.9596C34.4763 44.5112 34.2444 45.0566 34.0678 45.6197C33.9508 45.9917 33.7638 46.1515 33.3667 46.1505C31.8529 46.1442 30.3379 46.1714 28.8241 46.1578C28.6621 46.1568 28.4103 46.0126 28.3539 45.8736C27.8012 44.5029 27.2809 43.1186 26.7544 41.7374C26.7376 41.6935 26.7523 41.6371 26.7523 41.5159H26.7512Z",
        fill: "#00042B"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        d: "M26.8354 45.9898C23.0742 45.879 20.2272 43.8396 18.6966 40.0325C18.9703 40.0983 19.1908 40.1599 19.4154 40.2038C21.1685 40.5517 22.9238 40.8923 24.6758 41.2496C24.8399 41.2831 25.0739 41.3802 25.1241 41.5077C25.7091 42.9892 26.266 44.4822 26.8364 45.9898H26.8354Z",
        fill: "#00042B"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        d: "M43.5482 40.0879C42.1712 43.6255 39.2427 45.714 35.4971 45.9052C35.9056 44.8176 36.3852 43.7697 36.6871 42.6727C36.9682 41.6509 37.5041 41.2309 38.5667 41.0919C40.2289 40.8746 41.863 40.4389 43.5482 40.0879Z",
        fill: "#00042B"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        d: "M32.2841 12.3974C32.2841 13.1559 31.7241 13.717 30.9729 13.7107C30.2604 13.7055 29.6899 13.1382 29.6774 12.4215C29.6648 11.6912 30.2531 11.08 30.9729 11.0747C31.7074 11.0695 32.2831 11.6504 32.2831 12.3974H32.2841Z",
        fill: "#213251"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        d: "M28.0775 35.2215C27.5259 35.6865 22.513 35.5977 22.1108 35.1212C24.1565 35.0596 26.1175 35.0721 28.0775 35.2215Z",
        fill: "#00FFC6"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        d: "M33.9565 35.1744H39.7467C39.7623 35.2214 39.778 35.2684 39.7937 35.3154C39.6286 35.376 39.4635 35.4899 39.2985 35.4899C37.6331 35.4983 35.9688 35.4899 34.3034 35.4763C34.177 35.4753 34.0516 35.3907 33.9252 35.3447C33.9356 35.2872 33.9461 35.2308 33.9565 35.1733V35.1744Z",
        fill: "#00FFC6"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        d: "M40.1666 34.7398C40.0381 34.8098 39.9096 34.9404 39.7822 34.9404C37.889 34.9383 35.9949 34.9184 34.1017 34.9007C34.0777 34.9007 34.0537 34.862 33.9638 34.7826C34.1205 34.7105 34.2438 34.605 34.3681 34.6039C36.278 34.5935 38.1878 34.5966 40.0977 34.5966C40.1217 34.6447 40.1447 34.6917 40.1687 34.7398H40.1666Z",
        fill: "#00FFC6"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        d: "M21.8143 34.6804C22.742 34.4223 27.642 34.5487 27.9179 34.8235C27.0946 35.1495 22.1893 35.0638 21.8143 34.6804Z",
        fill: "#00FFC6"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        d: "M22.6559 35.6988C22.7854 35.6821 22.916 35.6497 23.0456 35.6497C24.4842 35.6455 25.9229 35.6382 27.3616 35.6539C27.5319 35.656 27.7011 35.7855 27.8704 35.8566C27.7095 35.9182 27.5496 36.0321 27.3887 36.0331C26.0023 36.0467 24.6148 36.0477 23.2284 36.03C23.0247 36.0279 22.823 35.9119 22.6204 35.8482C22.6319 35.798 22.6444 35.7489 22.6559 35.6988Z",
        fill: "#00FFC6"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        d: "M39.343 35.8533C39.1486 35.9149 38.9554 36.0267 38.761 36.0288C37.3527 36.0414 35.9433 36.0361 34.5349 36.0236C34.3719 36.0226 34.2089 35.9452 34.0564 35.7875C35.8054 35.5994 37.5449 35.5932 39.2855 35.6538L39.344 35.8533H39.343Z",
        fill: "#00FFC6"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        d: "M27.7198 36.2263C27.1849 36.7163 23.9492 36.6839 23.3955 36.2263H27.7198Z",
        fill: "#00FFC6"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        d: "M38.5769 36.2476C38.1078 36.6895 34.8377 36.7229 34.3529 36.2476H38.5769Z",
        fill: "#00FFC6"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        d: "M21.6617 33.9937C23.3835 34.0533 25.1042 34.1118 26.826 34.1713C26.8239 34.2173 26.8229 34.2643 26.8208 34.3103C25.9661 34.5495 21.8936 34.4461 21.646 34.1797C21.6512 34.117 21.6564 34.0554 21.6617 33.9927V33.9937Z",
        fill: "#00FFC6"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        d: "M35.1898 34.3853C36.8771 33.8964 38.5853 34.0646 40.2873 34.051C40.304 34.097 40.3207 34.1429 40.3374 34.1889C40.2633 34.2547 40.188 34.3759 40.1138 34.377C38.4725 34.3874 36.8312 34.3853 35.1909 34.3853H35.1898Z",
        fill: "#00FFC6"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        d: "M40.4513 33.8233H37.4706C37.9721 33.4461 40 33.3688 40.4513 33.8233Z",
        fill: "#00FFC6"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        d: "M21.5348 33.8024C22.0164 33.3845 23.919 33.4691 24.3609 33.8024H21.5348Z",
        fill: "#00FFC6"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        d: "M22.9943 33.2687H21.6799C22.1386 32.8153 22.5711 33.1057 22.9943 33.2687Z",
        fill: "#00FFC6"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        d: "M40.2491 33.2834H38.8094C39.3777 33.0567 39.8051 32.8414 40.2606 33.1413C40.2564 33.1883 40.2522 33.2364 40.248 33.2834H40.2491Z",
        fill: "#00FFC6"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        d: "M37.0886 36.9098H35.2655C35.2655 36.8669 35.2655 36.8241 35.2655 36.7812H37.0886C37.0886 36.8241 37.0886 36.8669 37.0886 36.9098Z",
        fill: "#00FFC6"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        d: "M26.6492 36.9068H24.8208C24.8208 36.8639 24.8208 36.8221 24.8208 36.7793H26.6429C26.645 36.8221 26.6471 36.8639 26.6492 36.9068Z",
        fill: "#00FFC6"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("defs", {
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("linearGradient", {
          id: "paint0_linear_5309_3548",
          x1: "30.9671",
          y1: "3",
          x2: "30.9671",
          y2: "53.9341",
          gradientUnits: "userSpaceOnUse",
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
            stopColor: "#243559"
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("stop", {
            offset: "1",
            stopColor: "#102232"
          })]
        })
      })]
    });
  }

  if (name === 'espn-long-icon') {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("svg", {
      className: className,
      focusable: focusable,
      "data-testid": testID,
      height: height,
      width: width,
      style: _objectSpread({}, style),
      viewBox: "0 0 229 56",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        d: "M90.9036 11C85.7743 10.9933 82.3774 13.6971 81.8995 17.7399C81.788 18.6743 81.6732 19.6082 81.555 20.5418H148.293C148.293 20.5418 148.419 19.5569 148.516 18.7664C149.018 14.6937 147.288 11.0005 140.994 11.0005V11.001C140.994 11.001 93.6077 11.003 90.9036 11ZM50.174 11.0013L49.0027 20.5418H79.2687L80.4355 11.0015H50.1735H50.174V11.0013ZM151.77 11.0013L150.601 20.5418H183.412C183.412 20.5418 183.452 20.1968 183.597 19.0738C184.396 12.8115 180.355 11.0013 176.455 11.0013H151.77ZM150.149 24.1744L147.593 44.9962L158.912 44.9922L161.471 24.1784L150.149 24.1739V24.1744ZM171.654 24.1744L169.093 44.9962L180.413 44.9922L182.972 24.1784L171.654 24.1739V24.1744ZM48.5612 24.1774L46 44.9972H76.264L77.379 35.9652L58.4285 35.9632L58.9078 32.0685H77.8509L78.8206 24.1779H48.5627L48.5612 24.1774ZM81.111 24.1774C80.2807 29.6113 83.0006 32.0677 86.8556 32.0677C88.9523 32.0677 102.168 32.0617 102.168 32.0617L101.69 35.9625L79.6654 35.9645L78.5563 44.9965C78.5563 44.9965 102.534 45.0044 103.506 44.9965C104.308 44.9387 109.917 44.7854 111.827 40.1977C112.446 38.7083 112.994 33.368 113.147 32.2469C114.029 25.7358 109.521 24.1834 105.971 24.1834C104.014 24.1834 84.9759 24.1774 81.111 24.1774ZM116.343 24.1774L113.786 44.9972H125.1L126.693 32.0685H140.904C144.934 32.0685 147.101 29.9016 147.503 26.9917C147.632 26.0553 147.748 25.1173 147.851 24.1779H116.343V24.1774Z",
        fill: "#E52534"
      })
    });
  }

  if (name === 'yahoo-long-icon') {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("svg", {
      className: className,
      focusable: focusable,
      "data-testid": testID,
      height: height,
      width: width,
      style: _objectSpread({}, style),
      viewBox: "0 0 229 56",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        d: "M106.046 9C106.044 10.445 106.042 11.8896 106.041 13.3345C106.04 14.4466 106.041 15.5583 106.041 16.6704C106.041 16.7383 106.041 16.8061 106.041 16.8736C106.058 16.8857 106.074 16.8977 106.091 16.9102C106.119 16.865 106.143 16.8152 106.178 16.7752C107.276 15.5169 108.69 15.0645 110.315 15.1651C111.276 15.2243 112.164 15.5067 112.935 16.1008C113.893 16.8393 114.451 17.8372 114.701 18.9975C114.834 19.6192 114.917 20.2642 114.922 20.8994C114.945 23.9209 114.933 26.9428 114.933 29.9647V30.1305H109.764V29.8738C109.764 27.3296 109.769 24.7849 109.758 22.2407C109.756 21.8743 109.713 21.498 109.62 21.1444C109.443 20.4757 109.01 20.035 108.304 19.9358C107.541 19.8288 106.897 20.0459 106.465 20.7241C106.209 21.126 106.089 21.5772 106.084 22.0469C106.069 23.297 106.073 24.5471 106.072 25.7971C106.07 27.1667 106.072 28.5363 106.072 29.9058V30.1369H100.9V29.8606C100.9 23.0003 100.9 16.14 100.899 9.27972C100.899 9.18661 100.888 9.09311 100.882 9C102.603 9 104.325 9 106.046 9L106.046 9Z",
        fill: "#39007D"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        d: "M66.5 15.4839C66.5939 15.488 66.6874 15.4956 66.7812 15.4956C68.4897 15.4963 70.1986 15.4986 71.907 15.4922C72.0646 15.4914 72.1332 15.5412 72.1901 15.6871C73.254 18.4213 74.3235 21.1537 75.3922 23.886C75.4145 23.9426 75.4401 23.998 75.4816 24.0945C75.5747 23.8634 75.6542 23.6704 75.7304 23.4766C76.7535 20.8811 77.777 18.2856 78.796 15.6886C78.851 15.548 78.917 15.491 79.078 15.4918C80.7552 15.499 82.4323 15.496 84.1095 15.496C84.1717 15.496 84.2343 15.496 84.3214 15.496C84.2991 15.5627 84.2856 15.6139 84.2656 15.6622C81.5336 22.2537 78.8009 28.8445 76.0697 35.4364C76.0308 35.5298 75.9928 35.5932 75.8714 35.5928C74.1252 35.589 72.3786 35.5898 70.6325 35.589C70.608 35.589 70.5835 35.5822 70.5314 35.5747C70.5571 35.5053 70.5774 35.4443 70.6023 35.3855C71.3001 33.7335 71.9971 32.0812 72.6983 30.4308C72.7462 30.3181 72.7466 30.2269 72.6983 30.1134C70.6543 25.2937 68.6134 20.4725 66.5712 15.6516C66.552 15.6064 66.5241 15.5649 66.5 15.5216C66.5 15.5091 66.5 15.4963 66.5 15.4839Z",
        fill: "#39007D"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        d: "M162.403 9.0377C162.276 9.3291 162.144 9.61863 162.022 9.91229C160.34 13.972 158.659 18.0325 156.98 22.0933C156.934 22.2034 156.898 22.281 156.746 22.2803C154.812 22.2739 152.878 22.2761 150.943 22.2758C150.9 22.2758 150.856 22.2701 150.783 22.2652C150.814 22.1853 150.838 22.1186 150.865 22.053C152.643 17.7546 154.422 13.4563 156.199 9.15795C156.221 9.10593 156.239 9.05278 156.259 9C158.257 9 160.255 9 162.253 9.00151C162.303 9.00151 162.353 9.02488 162.403 9.0377Z",
        fill: "#39007D"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        d: "M152.677 46.9997C153.006 46.2333 153.335 45.4669 153.664 44.7005C153.743 44.5161 153.809 44.325 153.901 44.1478C153.98 43.997 153.958 43.8692 153.896 43.7219C152.792 41.1041 151.692 38.4848 150.592 35.8656C150.564 35.7981 150.541 35.728 150.509 35.6405C150.584 35.6352 150.638 35.6281 150.692 35.6281C151.609 35.6273 152.527 35.6307 153.444 35.6243C153.589 35.6232 153.649 35.6748 153.699 35.8071C154.256 37.2857 154.82 38.7612 155.383 40.2378C155.413 40.3158 155.447 40.3924 155.48 40.4693L155.53 40.467C155.562 40.3897 155.597 40.3128 155.628 40.2344C156.204 38.763 156.782 37.2924 157.351 35.8188C157.408 35.6699 157.482 35.6228 157.638 35.6243C158.511 35.6315 159.385 35.6277 160.258 35.6281C160.314 35.6281 160.369 35.6326 160.447 35.636C160.426 35.7008 160.413 35.7529 160.393 35.8022C158.875 39.4703 157.357 43.1379 155.839 46.8059C155.813 46.8696 155.792 46.9352 155.768 47.0001H152.677L152.677 46.9997Z",
        fill: "#6007D5"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        d: "M94.1732 30.138V28.8076C94.1324 28.8423 94.1083 28.8574 94.0913 28.8781C93.3502 29.7847 92.3682 30.2695 91.2353 30.4418C88.1558 30.91 85.2892 29.3512 84.0071 26.4021C82.7043 23.4055 82.958 20.5005 84.9107 17.8363C86.0127 16.3329 87.5319 15.4399 89.3961 15.2035C90.875 15.0161 92.2619 15.2789 93.4769 16.1953C93.7193 16.3782 93.9289 16.6051 94.1705 16.8275V15.5066H99.1527V30.1376H94.1732V30.138ZM94.2885 22.8483C94.29 21.1432 92.9713 19.8185 91.2738 19.8193C89.5578 19.82 88.2229 21.1425 88.2248 22.8408C88.2267 24.5372 89.5502 25.8532 91.2568 25.8558C92.9676 25.8581 94.2874 24.5492 94.2885 22.8483Z",
        fill: "#39007D"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        d: "M148.262 22.8423C148.237 26.5879 145.818 29.6098 142.144 30.3479C139.599 30.8591 137.239 30.3781 135.214 28.684C133.663 27.386 132.825 25.6873 132.624 23.6814C132.434 21.7784 132.821 20.0032 133.92 18.421C135.166 16.6296 136.905 15.6046 139.045 15.2608C140.825 14.975 142.547 15.1911 144.152 16.0276C146.438 17.2181 147.759 19.1196 148.154 21.6623C148.214 22.0517 148.227 22.4487 148.262 22.8423H148.262ZM140.405 25.8019C142.039 25.8159 143.319 24.5383 143.335 22.8777C143.352 21.1881 142.107 19.8995 140.442 19.8841C138.78 19.8686 137.494 21.1319 137.481 22.7925C137.468 24.5002 138.718 25.7876 140.404 25.8019H140.405Z",
        fill: "#39007D"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        d: "M131.706 22.84C131.684 26.6664 129.134 29.7486 125.37 30.3928C122.883 30.8185 120.592 30.3186 118.632 28.6621C117.185 27.44 116.358 25.8555 116.106 23.983C115.838 21.9922 116.197 20.1258 117.343 18.455C118.586 16.6436 120.333 15.6084 122.488 15.2616C124.268 14.9751 125.99 15.1907 127.595 16.0269C129.895 17.2241 131.217 19.1381 131.603 21.6974C131.66 22.0748 131.673 22.4593 131.706 22.84ZM123.868 25.8023C125.536 25.7937 126.792 24.5014 126.783 22.8042C126.774 21.1406 125.495 19.8747 123.833 19.8845C122.168 19.8943 120.918 21.1787 120.929 22.8672C120.94 24.5364 122.216 25.8114 123.868 25.8027V25.8023Z",
        fill: "#39007D"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        d: "M139.347 36.4624C139.347 36.2257 139.353 36.0074 139.346 35.7895C139.341 35.6662 139.386 35.6251 139.509 35.6255C140.382 35.6293 141.255 35.6296 142.129 35.6247C142.265 35.624 142.298 35.676 142.297 35.8027C142.295 38.4415 142.295 41.0804 142.297 43.7193C142.297 43.8482 142.26 43.8953 142.126 43.8946C141.253 43.8897 140.38 43.89 139.506 43.8946C139.38 43.8953 139.342 43.8482 139.345 43.7283C139.352 43.5063 139.347 43.2835 139.347 43.0611C139.319 43.0441 139.292 43.0275 139.264 43.0106C139.23 43.0686 139.205 43.135 139.161 43.184C138.679 43.7148 138.071 43.9967 137.368 44.0831C135.271 44.3402 133.692 42.9186 133.234 41.1709C132.826 39.614 132.998 38.1366 133.997 36.8326C134.825 35.7525 135.957 35.2911 137.305 35.4121C138.059 35.48 138.721 35.7846 139.219 36.3832C139.235 36.4025 139.253 36.4209 139.272 36.4371C139.28 36.4443 139.294 36.4451 139.347 36.4624H139.347ZM139.424 39.7459C139.423 38.7985 138.665 38.0525 137.701 38.0506C136.727 38.0491 135.968 38.7974 135.96 39.7512C135.954 40.5971 136.605 41.4589 137.697 41.4548C138.854 41.4506 139.458 40.5176 139.423 39.7455L139.424 39.7459Z",
        fill: "#6007D5"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        d: "M113.563 36.4459C113.563 36.2408 113.571 36.0353 113.56 35.8306C113.552 35.6783 113.597 35.6225 113.758 35.6241C114.612 35.6312 115.466 35.6305 116.32 35.6244C116.468 35.6233 116.515 35.6666 116.514 35.8171C116.506 36.4263 116.51 37.0355 116.51 37.6443C116.51 39.654 116.508 41.6633 116.514 43.673C116.514 43.8445 116.472 43.8984 116.294 43.8965C115.453 43.8871 114.611 43.8878 113.77 43.8961C113.601 43.8976 113.55 43.8456 113.56 43.6816C113.573 43.4769 113.563 43.2707 113.563 43.0046C113.472 43.0932 113.421 43.1395 113.374 43.1908C112.894 43.7133 112.292 43.9957 111.596 44.082C109.469 44.3463 107.887 42.9005 107.439 41.1317C107.047 39.5884 107.23 38.128 108.212 36.8289C109.205 35.5144 110.997 35.0311 112.463 35.6591C112.821 35.8125 113.128 36.035 113.387 36.3252C113.427 36.3709 113.468 36.4161 113.509 36.4617C113.527 36.4564 113.545 36.4508 113.563 36.4455V36.4459ZM113.639 39.758C113.639 38.7979 112.883 38.0507 111.91 38.0507C110.947 38.0507 110.18 38.7986 110.177 39.7392C110.175 40.6963 110.929 41.4661 111.901 41.4582C113.031 41.4492 113.667 40.5584 113.639 39.7576V39.758Z",
        fill: "#6007D5"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        d: "M120.783 36.5657C121.022 36.3225 121.199 36.1092 121.409 35.9354C121.839 35.5795 122.349 35.4231 122.904 35.3997C123.479 35.3756 124.031 35.4585 124.537 35.7488C125.307 36.1906 125.692 36.8952 125.854 37.737C125.91 38.0242 125.932 38.3217 125.933 38.6146C125.94 40.2978 125.934 41.981 125.941 43.6642C125.942 43.8448 125.893 43.8987 125.71 43.8965C124.855 43.887 124.001 43.8886 123.147 43.8957C122.989 43.8972 122.946 43.8475 122.946 43.6925C122.952 42.2543 122.953 40.8162 122.945 39.378C122.944 39.1748 122.906 38.9648 122.845 38.7707C122.715 38.3556 122.409 38.1321 121.981 38.1023C121.585 38.0748 121.257 38.2169 121.029 38.558C120.808 38.889 120.787 39.2664 120.785 39.643C120.78 40.9745 120.783 42.306 120.783 43.6375C120.783 43.8074 120.696 43.8923 120.522 43.8923C119.687 43.8923 118.851 43.8882 118.016 43.8961C117.848 43.8976 117.803 43.8418 117.803 43.6801C117.807 41.0672 117.807 38.4548 117.803 35.8419C117.803 35.6821 117.845 35.6225 118.015 35.624C118.869 35.6319 119.723 35.6319 120.577 35.624C120.75 35.6225 120.793 35.6862 120.786 35.8442C120.775 36.0719 120.783 36.3007 120.783 36.5661L120.783 36.5657Z",
        fill: "#6007D5"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        d: "M107.162 34.2501C106.899 34.2045 106.668 34.1533 106.434 34.1261C105.558 34.0236 104.991 34.5574 105.009 35.4474C105.012 35.5903 105.063 35.6303 105.197 35.6291C105.743 35.6242 106.29 35.6329 106.836 35.6239C106.997 35.6212 107.055 35.6608 107.052 35.8323C107.042 36.4917 107.042 37.151 107.052 37.8103C107.055 37.9845 106.993 38.0192 106.834 38.0166C106.307 38.0079 105.779 38.0207 105.252 38.009C105.064 38.0049 105.006 38.055 105.007 38.2495C105.015 40.0519 105.009 41.8542 105.016 43.6566C105.017 43.85 104.963 43.899 104.773 43.8963C103.944 43.8858 103.115 43.8918 102.286 43.8918C102.113 43.8918 102.027 43.808 102.027 43.6404C102.027 41.8444 102.024 40.0481 102.031 38.2522C102.032 38.0622 101.983 37.9962 101.79 38.0094C101.552 38.0256 101.312 38.0101 101.074 38.0143C100.971 38.0162 100.927 37.9792 100.927 37.8725C100.929 37.1691 100.929 36.4657 100.927 35.7626C100.927 35.6514 100.981 35.6246 101.079 35.6257C101.311 35.6291 101.544 35.6273 101.776 35.6265C102.026 35.6257 102.024 35.6254 102.027 35.3807C102.036 34.7689 102.109 34.168 102.347 33.5976C102.822 32.4587 103.707 31.8458 104.895 31.6354C105.538 31.5216 106.18 31.5336 106.813 31.7082C107.046 31.7725 107.162 31.9232 107.162 32.1602C107.162 32.7882 107.162 33.4163 107.162 34.0443V34.2498V34.2501Z",
        fill: "#6007D5"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        d: "M143.027 43.1139C143.379 42.4003 143.719 41.7104 144.054 41.0326C144.478 41.2019 144.874 41.3738 145.28 41.5189C145.852 41.7236 146.447 41.8077 147.055 41.7742C147.099 41.7719 147.144 41.7708 147.187 41.7625C147.424 41.7154 147.556 41.6 147.565 41.4304C147.577 41.2019 147.407 41.1235 147.237 41.0764C146.701 40.9271 146.157 40.8034 145.621 40.6508C145.025 40.4815 144.457 40.2478 144.005 39.8014C143.641 39.441 143.459 38.9988 143.417 38.4922C143.273 36.7139 144.486 35.8393 145.706 35.5532C147.034 35.2418 148.321 35.4341 149.579 35.9046C149.808 35.9901 150.029 36.0957 150.254 36.1914C150.339 36.2276 150.387 36.268 150.34 36.3758C150.053 37.037 149.772 37.7005 149.481 38.3821C149.404 38.3485 149.336 38.3206 149.27 38.2905C148.505 37.9414 147.721 37.6688 146.862 37.7111C146.762 37.716 146.661 37.7292 146.567 37.7582C146.431 37.7996 146.342 37.892 146.331 38.0432C146.319 38.1992 146.422 38.2773 146.545 38.3161C146.909 38.4318 147.276 38.5385 147.643 38.643C148.351 38.8443 149.053 39.0618 149.652 39.5108C150.334 40.0204 150.59 40.713 150.495 41.5442C150.343 42.881 149.493 43.5814 148.281 43.9271C147.467 44.1589 146.636 44.1559 145.8 44.0511C144.9 43.9384 144.044 43.6956 143.25 43.2531C143.18 43.2138 143.113 43.1679 143.027 43.1139H143.027Z",
        fill: "#6007D5"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        d: "M132.517 41.326C132.524 41.3878 132.533 41.4361 132.533 41.4843C132.533 42.2066 132.532 42.9293 132.535 43.6516C132.535 43.7496 132.521 43.822 132.412 43.8514C131.403 44.1266 130.385 44.2393 129.378 43.8816C128.425 43.543 127.896 42.8196 127.703 41.8451C127.65 41.5767 127.629 41.2981 127.626 41.024C127.616 40.1008 127.617 39.1772 127.626 38.254C127.628 38.0632 127.573 37.9976 127.381 38.0101C127.143 38.0252 126.904 38.0097 126.665 38.0154C126.549 38.018 126.493 37.9863 126.494 37.8578C126.498 37.1668 126.498 36.4758 126.494 35.7848C126.493 35.6566 126.548 35.6234 126.665 35.6261C126.916 35.6313 127.167 35.6208 127.418 35.6298C127.573 35.6355 127.626 35.5797 127.624 35.4236C127.618 34.7138 127.626 34.0039 127.619 33.2941C127.617 33.1286 127.652 33.0633 127.835 33.0652C128.677 33.075 129.519 33.0739 130.36 33.066C130.532 33.0645 130.59 33.1123 130.588 33.2884C130.579 33.9794 130.584 34.6704 130.584 35.3614C130.584 35.6261 130.586 35.6268 130.843 35.6272C131.345 35.6276 131.848 35.6313 132.35 35.6249C132.487 35.623 132.537 35.6634 132.536 35.8063C132.529 36.4848 132.53 37.163 132.535 37.8416C132.536 37.972 132.495 38.0172 132.362 38.0157C131.841 38.0101 131.32 38.0195 130.798 38.0101C130.629 38.0071 130.58 38.0693 130.583 38.228C130.595 38.9936 130.594 39.76 130.612 40.5257C130.624 41.0595 130.986 41.4244 131.523 41.4285C131.808 41.4308 132.094 41.3731 132.38 41.3422C132.421 41.3377 132.462 41.3324 132.516 41.3264L132.517 41.326Z",
        fill: "#6007D5"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("path", {
        d: "M152.376 23.5808C154.286 23.5835 155.733 25.0394 155.729 26.9544C155.725 28.8974 154.186 30.4177 152.23 30.411C150.355 30.4045 148.902 28.9347 148.902 27.0456C148.902 25.1155 150.444 23.5778 152.376 23.5808H152.376Z",
        fill: "#39007D"
      })]
    });
  }

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("svg", {
    className: className,
    fill: fill,
    focusable: focusable,
    "data-testid": testID,
    height: height,
    width: width,
    style: _objectSpread({}, style),
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("use", {
      xlinkHref: href
    })
  });
};

/***/ }),

/***/ 1486:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* reexport safe */ _pff_consumer_tweed_ui_atoms_icon_icon_web__WEBPACK_IMPORTED_MODULE_0__.J; }
/* harmony export */ });
/* harmony import */ var _pff_consumer_tweed_ui_atoms_icon_icon_web__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48793);


/***/ }),

/***/ 24168:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "z": function() { return /* binding */ Button; }
});

// EXTERNAL MODULE: ../../../../../../../../local-cache/custom/dba27c31aad935787bb275c3e5e4e957708f15386de599eff1db476022cd7e4c/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(19915);
// EXTERNAL MODULE: ../../../../../../../../local-cache/custom/dba27c31aad935787bb275c3e5e4e957708f15386de599eff1db476022cd7e4c/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(56161);
// EXTERNAL MODULE: ../../../../../../../../local-cache/custom/dba27c31aad935787bb275c3e5e4e957708f15386de599eff1db476022cd7e4c/node_modules/react/index.js
var react = __webpack_require__(49053);
// EXTERNAL MODULE: ../../libs/web-ui/src/components/icon/icon.tsx
var icon = __webpack_require__(1486);
// EXTERNAL MODULE: ../../libs/utils/src/index.ts + 64 modules
var src = __webpack_require__(40418);
// EXTERNAL MODULE: ../../libs/web-ui/src/styles/index.ts + 1 modules
var styles = __webpack_require__(1529);
;// CONCATENATED MODULE: ./components/common/button/button.styles.ts


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


var useStyles = (0,styles/* createUseStyles */.QM)(function (theme) {
  return {
    button: function button(props) {
      var baseStyles = {
        backgroundColor: theme.colors.webButtonBackground,
        borderRadius: theme.calcUnit(theme.borderRadius.roundedDefault),
        color: theme.colors.webInverseTextColor,
        cursor: 'pointer',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        opacity: 1,
        padding: props.size === 'lg' ? theme.calcUnit(theme.spacing.s5) : theme.calcUnit(theme.spacing.s4),
        width: '100%',
        position: 'relative'
      };

      switch (props.variant) {
        case 'SocialMedia':
          {
            return _objectSpread(_objectSpread({}, baseStyles), {}, {
              backgroundColor: theme.colors.webBrightBackground,
              border: "".concat(theme.calcUnit(1), " solid ").concat(theme.colors.webButtonBackground),
              padding: theme.calcUnit(theme.spacing.s4)
            });
          }

        case 'Remove':
          {
            return _objectSpread(_objectSpread({}, baseStyles), {}, {
              backgroundColor: theme.colors.webErrorColor
            });
          }

        case 'Cancel':
          {
            return {
              backgroundColor: theme.colors.webBrightBackground,
              color: theme.colors.webHeadingText,
              borderRadius: theme.calcUnit(theme.borderRadius.roundedDefault),
              border: "".concat(theme.calcUnit(1), " solid ").concat(theme.colors.webButtonBorder)
            };
          }

        case 'Submit':
          {
            return _objectSpread(_objectSpread({}, baseStyles), {}, {
              color: theme.colors.webInverseTextColor
            });
          }

        default:
          {
            return baseStyles;
          }
      }
    },
    spinnerContainer: function spinnerContainer(_ref) {
      var size = _ref.size;

      if (size === 'sm') {
        return {
          position: 'absolute',
          left: '10%'
        };
      }

      return {};
    },
    buttonDisabled: {
      cursor: 'auto !important',
      opacity: '0.5 !important'
    },
    buttonLogo: {
      marginRight: theme.calcUnit(theme.spacing.s2)
    },
    buttonText: {
      fontFamily: 'Roboto',
      fontStyle: 'normal',
      fontWeight: 500,
      fontSize: theme.calcUnit(theme.spacing.s4),
      lineHeight: theme.calcUnit(19),
      textTransform: 'uppercase'
    }
  };
});
// EXTERNAL MODULE: ../../../../../../../../local-cache/custom/dba27c31aad935787bb275c3e5e4e957708f15386de599eff1db476022cd7e4c/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(260);
;// CONCATENATED MODULE: ./components/common/button/button.tsx


var _excluded = ["type", "children", "onClick", "iconName", "iconWidth", "iconHeight", "disabled", "text", "className", "size"];

function button_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function button_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? button_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : button_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }




 // TODO - USE TWEED



var Button = function Button(props) {
  var type = props.type,
      children = props.children,
      onClick = props.onClick,
      iconName = props.iconName,
      iconWidth = props.iconWidth,
      iconHeight = props.iconHeight,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$text = props.text,
      text = _props$text === void 0 ? '' : _props$text,
      className = props.className,
      _props$size = props.size,
      size = _props$size === void 0 ? 'lg' : _props$size,
      other = (0,objectWithoutProperties/* default */.Z)(props, _excluded);

  var styles = useStyles(props);
  var isLargeBtn = size === 'lg';
  var clsName = disabled ? "".concat(styles.button, " ").concat(styles.buttonText, " ").concat(className, " ").concat(styles.buttonDisabled) : "".concat(styles.button, " ").concat(styles.buttonText, " ").concat(className);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)("button", button_objectSpread(button_objectSpread({
    type: type === 'submit' ? 'submit' : 'button',
    className: clsName,
    onClick: onClick,
    disabled: disabled
  }, other), {}, {
    children: [iconName && /*#__PURE__*/(0,jsx_runtime.jsx)(icon/* Icon */.J, {
      name: iconName,
      group: src/* SVGGroup.Icons */.OM.Icons,
      width: iconWidth,
      height: iconHeight
    }), children, isLargeBtn && text]
  }));
};

/***/ }),

/***/ 65218:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Pm": function() { return /* binding */ CTALocation; },
/* harmony export */   "R4": function() { return /* binding */ PROGRESS_BAR_STEP; },
/* harmony export */   "SD": function() { return /* binding */ CTAName; },
/* harmony export */   "fq": function() { return /* binding */ EspnProgressBarStep; },
/* harmony export */   "q4": function() { return /* binding */ ProgressBarStep; },
/* harmony export */   "uy": function() { return /* binding */ ESPN_PROGRESS_BAR_STEP; }
/* harmony export */ });
var ProgressBarStep;

(function (ProgressBarStep) {
  ProgressBarStep[ProgressBarStep["CHOOSE_FANTASY_PROVIDER"] = 1] = "CHOOSE_FANTASY_PROVIDER";
  ProgressBarStep[ProgressBarStep["ENTER_DETAILS_FOR_FANTASY_PROVIDER"] = 2] = "ENTER_DETAILS_FOR_FANTASY_PROVIDER";
  ProgressBarStep[ProgressBarStep["CONFIRM_FANTASY_LEAGUE_TO_SYNC"] = 3] = "CONFIRM_FANTASY_LEAGUE_TO_SYNC";
})(ProgressBarStep || (ProgressBarStep = {}));

var EspnProgressBarStep;

(function (EspnProgressBarStep) {
  EspnProgressBarStep[EspnProgressBarStep["CHOOSE_FANTASY_PROVIDER"] = 1] = "CHOOSE_FANTASY_PROVIDER";
  EspnProgressBarStep[EspnProgressBarStep["REDIRECT_TO_EXTENSION"] = 2] = "REDIRECT_TO_EXTENSION";
  EspnProgressBarStep[EspnProgressBarStep["REDIRECT_TO_ESPN"] = 3] = "REDIRECT_TO_ESPN";
  EspnProgressBarStep[EspnProgressBarStep["ENTER_DETAILS_FOR_FANTASY_PROVIDER"] = 4] = "ENTER_DETAILS_FOR_FANTASY_PROVIDER";
  EspnProgressBarStep[EspnProgressBarStep["CONFIRM_FANTASY_LEAGUE_TO_SYNC"] = 5] = "CONFIRM_FANTASY_LEAGUE_TO_SYNC";
})(EspnProgressBarStep || (EspnProgressBarStep = {}));

var CTALocation;

(function (CTALocation) {
  CTALocation["CREATE_FREE_ACCOUNT"] = "Create Free Account";
  CTALocation["LEAGUE_SYNC_STEP_ONE"] = "League Sync Step 1";
  CTALocation["LEAGUE_SYNC_STEP_TWO"] = "League Sync Step 2";
  CTALocation["LEAGUE_SYNC_STEP_THREE"] = "League Sync Step 3";
  CTALocation["DELETE_LEAGUE_MODEL"] = "Delete League Modal";
  CTALocation["MY_LEAGUE"] = "My Leagues";
})(CTALocation || (CTALocation = {}));

var CTAName;

(function (CTAName) {
  CTAName["GO_TO_MY_LEAGUE"] = "Go To My Leagues";
  CTAName["TRY_SYNC_AGAIN"] = "Try Sync Again";
  CTAName["START_LEAGUE_SYNC"] = "Start League Sync";
  CTAName["SYNC_LEAGUE"] = "Sync League";
})(CTAName || (CTAName = {}));

var PROGRESS_BAR_STEP = ['1', '2', '3'];
var ESPN_PROGRESS_BAR_STEP = ['1', '2', '3', '4', '5'];

/***/ }),

/***/ 10576:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Routes; }
/* harmony export */ });
var Routes = {
  Home: '/',
  Login: '/login',
  CreateAccount: '/create-account',
  LeagueSync: '/fantasy/league-sync',
  MyLeagues: '/fantasy/leagues',
  MockDraftSimulator: '/fantasy/draft/mock-draft-simulator',
  LiveDraftAssistant: '/fantasy/draft/live-draft-assistant'
};

/***/ })

}]);